var _style, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3419.3018,
    y1: 3609.677,
    x2: 1372.696,
    y2: 1400.6421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M3134.094,2350.831c-281.219,657.315-1023.545,939.648-1605.169,891.51    c-158.807-13.143-478.33-39.589-727.817-275.52c-479.121-453.091-405.332-1400.176,53.324-1957.768    c59.066-71.806,467.908-552.901,1105.013-546.461c466.454,4.715,793.853,268.208,833.663,301.035    c50.291,41.468,161.214,140.01,261.181,296.341C3289.18,1427.29,3309.827,1940.074,3134.094,2350.831z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101801874046575175240000002239721157274167958_",
    gradientUnits: "userSpaceOnUse",
    x1: 1619.3109,
    y1: 2665.9617,
    x2: 2232.7273,
    y2: 825.707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101801874046575175240000002239721157274167958_)"
    },
    d: "M3127.82,2755.289      c0,27.15-20.419,49.364-45.375,49.364H628.761c-24.956,0-45.375-22.214-45.375-49.364l-20.417-1535.52      c0-27.15,29.375-80.155,83.208-76.172l2398.011-67.569c31.312-0.882,61.588,12.242,83.762,36.31      c22.174,24.068,34.306,56.975,33.567,91.042L3127.82,2755.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3083.023,2707.93c0,25.71-19.318,46.746-42.928,46.746H687.933      c-23.61,0-42.927-21.036-42.927-46.746L625.74,1313.971c2.269-83.885,69.804-114.034,110.743-112.254      c0,0,1874.264-54.757,2298.274-67.145c21.999-0.643,43.268,8.587,58.849,25.511c15.581,16.923,24.15,40.084,23.598,64.041      L3083.023,2707.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044887048292515824600000006761486689679133574_",
    gradientUnits: "userSpaceOnUse",
    x1: 1956.1681,
    y1: 1755.1035,
    x2: 1828.9064,
    y2: 3149.8879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044887048292515824600000006761486689679133574_)"
    },
    d: "M3238.18,2932.121H471.682     c-4.128,0-7.505-3.377-7.505-7.505v-119.906c0-4.128,3.377-7.505,7.505-7.505H3238.18c4.128,0,7.505,3.377,7.505,7.505v119.906     C3245.685,2928.743,3242.307,2932.121,3238.18,2932.121z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M720.044,1284.381l1636.957-38.364c26.624-0.624,48.663,15.212,48.663,34.966v18.195     c0,18.976-20.399,34.492-45.978,34.972l-1636.253,30.737c-25.602,0.481-47.046-14.276-48.31-33.245l-0.704-10.568     C673.116,1301.534,693.676,1284.999,720.044,1284.381z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086677989586456231110000000399181706623452314_",
    gradientUnits: "userSpaceOnUse",
    x1: 2215.9319,
    y1: 1300.1135,
    x2: 2357.1829,
    y2: 1300.1135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086677989586456231110000000399181706623452314_)"
    },
    d: "M2356.777,1289.405     c3.475-27.728-15.779-52.972-43.007-56.385c-27.228-3.413-52.117,16.298-55.593,44.026c-1.816,14.489,2.583,28.293,11.075,38.665     l-50.689,38.995c-3.204,2.577-3.533,7.337-0.715,10.33l0.463,0.492c2.493,2.649,6.666,2.761,9.299,0.251l46.048-45.347     c7.345,6.923,16.814,11.656,27.526,12.998C2328.412,1336.844,2353.302,1317.132,2356.777,1289.405z M2302.868,1320.001     c-19.944-2.5-34.048-20.991-31.503-41.302c2.546-20.311,20.778-34.749,40.722-32.249c19.944,2.5,34.048,20.991,31.502,41.302     C2341.044,1308.063,2322.812,1322.501,2302.868,1320.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M689.216,1993.586l27.298,660.43c0.92,22.263,32.007,39.939,69.7,39.632l801.42-6.519     c37.676-0.306,67.92-18.465,67.827-40.724l-2.786-666.623c-0.095-22.813-31.96-41.108-70.565-40.514l-825.932,12.712     C718.252,1952.564,688.29,1971.181,689.216,1993.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1809.561,1409.116l502.398-6.11c51.423-0.625,94.059,16.074,94.489,37.008l8.531,415.164     c0.43,20.921-41.464,37.903-92.874,37.646l-523.021-2.612c-29.426-0.147-53.286-9.746-53.983-21.718l-24.525-421.174     C1719.381,1426.796,1759.132,1409.729,1809.561,1409.116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M815.313,1399.612l714.931-6.297c73.176-0.644,133.849,16.566,134.462,38.14l12.141,427.868     c0.612,21.562-59.005,39.063-132.164,38.798l-744.279-2.692c-41.874-0.151-75.828-10.044-76.82-22.383l-34.9-434.062     C686.983,1417.833,743.55,1400.244,815.313,1399.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1808.367,1943.729l502.398-9.696c51.423-0.992,94.059,25.509,94.489,58.731l8.531,658.864     c0.43,33.202-41.464,60.152-92.874,59.744l-523.021-4.145c-29.426-0.233-53.286-15.467-53.983-34.467l-24.525-668.402     C1718.186,1971.787,1757.938,1944.702,1808.367,1943.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2545.907,1227.5l391.95-6.311c40.118-0.646,73.381,16.603,73.717,38.226l6.656,428.829     c0.335,21.61-32.349,39.15-72.457,38.885l-408.04-2.698c-22.957-0.152-41.572-10.067-42.115-22.433l-19.133-435.037     C2475.552,1245.761,2506.565,1228.133,2545.907,1227.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2555.537,1784.707l391.95-4.952c40.118-0.507,73.381,13.027,73.717,29.993l6.656,336.471     c0.335,16.956-32.349,30.719-72.457,30.51l-408.04-2.117c-22.957-0.119-41.571-7.899-42.115-17.602l-19.133-341.341     C2485.182,1799.036,2516.194,1785.204,2555.537,1784.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      fill: "#FFFFFF"
    },
    d: "M2574.231,2251.89l391.95-5.7c40.118-0.583,73.381,14.996,73.717,34.526     l6.656,387.326c0.335,19.519-32.349,35.362-72.457,35.122l-408.04-2.437c-22.957-0.137-41.572-9.093-42.115-20.262     l-19.133-392.933C2503.876,2268.385,2534.888,2252.462,2574.231,2251.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001659129462553831130000014155783632331385013_",
    gradientUnits: "userSpaceOnUse",
    x1: 1315.6337,
    y1: -123.9016,
    x2: 1313.4421,
    y2: 210.3025,
    gradientTransform: "matrix(-0.9036 -0.4283 -0.4283 0.9036 3932.531 1216.7393)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001659129462553831130000014155783632331385013_)"
    },
    d: "M2624.947,743.433      c0.475-1.064,0.944-2.133,1.44-3.18c24.094-50.837,63.971-61.355,99.117-44.698c35.146,16.658,52.252,54.184,28.157,105.02      c-0.208,0.439-0.438,0.875-0.651,1.314C2729.321,784.15,2683.83,755.445,2624.947,743.433z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096751467314812869570000004399907846214255761_",
    gradientUnits: "userSpaceOnUse",
    x1: 1840.5221,
    y1: 723.4649,
    x2: 1645.5687,
    y2: 1134.5615,
    gradientTransform: "matrix(-0.4785 -0.8781 -0.8781 0.4785 4225.6958 2016.3077)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096751467314812869570000004399907846214255761_)"
    },
    d: "M2753.011,801.889      c-24.431,50.291-79.917,94.274-114.76,77.761c-34.422-16.314-35.894-85.609-13.305-136.217      C2683.83,755.445,2729.321,784.15,2753.011,801.889z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149340853303153931600000014691894853965234073_",
    gradientUnits: "userSpaceOnUse",
    x1: 1376.7059,
    y1: -123.4934,
    x2: 1374.5146,
    y2: 210.6988,
    gradientTransform: "matrix(-0.9036 -0.4283 -0.4283 0.9036 3932.531 1216.7393)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149340853303153931600000014691894853965234073_)"
    },
    d: "M2691.633,716.329     c11.958-21.557,22.464-43.835,30.822-67.1c4.041-11.669,7.624-23.577,9.537-35.967c1.002-6.18,1.406-12.518,1.124-18.919     c-0.274-6.375-1.721-13.013-5.134-18.935c-3.373-5.97-9.3-10.517-15.695-12.61c-6.457-2.247-12.98-2.596-19.497-2.164     c-6.488,0.461-13.531,2.374-18.941,7.287c-5.566,4.828-7.907,12.217-8.296,18.896c-0.431,6.815,0.96,13.379,3.186,19.549     c2.311,6.153,5.402,12.05,10.395,17.067c2.547,2.399,5.563,4.943,10.217,5.616c2.319,0.277,4.915-0.202,6.937-1.387     c2.13-1.181,3.433-2.769,4.726-4.363c4.116-6.507,5.063-13.025,6.041-19.391c0.368-2.393-1.274-4.631-3.667-4.999     c-2.393-0.368-4.631,1.274-4.999,3.667c-0.007,0.044-0.013,0.087-0.018,0.13l-0.025,0.207     c-0.675,5.685-1.823,11.617-4.274,15.572c-1.374,1.818-2.401,2.443-3.776,2.329c-1.509-0.101-3.677-1.461-5.503-3.219     c-3.772-3.606-6.702-8.726-8.74-13.979c-2.022-5.279-3.29-10.963-3.014-16.415c0.257-5.406,1.896-10.662,5.698-14.023     c3.667-3.478,9.034-5.228,14.65-5.71c11.378-1.164,23.699,1.546,29.251,11.129c2.793,4.648,4.254,10.316,4.586,16.142     c0.351,5.827,0.1,11.789-0.762,17.722c-1.62,11.883-4.915,23.622-8.691,35.156c-7.816,23.017-17.902,45.409-29.347,66.904     l-0.026,0.047c-0.478,0.898-0.138,2.013,0.76,2.491C2690.045,717.534,2691.146,717.205,2691.633,716.329z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109748589535356996540000000327952849179263368_",
    gradientUnits: "userSpaceOnUse",
    x1: 1257.0273,
    y1: -124.283,
    x2: 1254.8359,
    y2: 209.9149,
    gradientTransform: "matrix(-0.9036 -0.4283 -0.4283 0.9036 3932.531 1216.7393)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109748589535356996540000000327952849179263368_)"
    },
    d: "M2730.604,734.516     c9.391-22.469,20.338-44.453,33.205-65.076c6.537-10.226,13.538-20.208,21.71-28.986c4.046-4.424,8.502-8.393,13.235-11.811     c4.72-3.432,10.032-5.89,15.398-6.671c10.933-1.77,20.831,6.05,27.134,15.595c3.183,4.652,5.226,9.915,4.856,14.956     c-0.194,5.07-3.226,9.667-7.247,13.288c-4.045,3.665-9.248,6.283-14.614,8.06c-5.355,1.748-11.174,2.722-16.354,2.085     c-2.518-0.3-4.943-1.118-5.977-2.222c-0.958-0.992-1.125-2.182-0.588-4.397c1.509-4.401,5.374-9.045,9.347-13.167l0.132-0.137     c1.68-1.743,1.629-4.518-0.115-6.199c-1.743-1.68-4.519-1.629-6.199,0.115c-0.03,0.031-0.073,0.077-0.102,0.11     c-4.308,4.787-8.754,9.647-11.184,16.953c-0.416,2.01-0.82,4.024-0.385,6.421c0.363,2.316,1.635,4.628,3.318,6.248     c3.467,3.176,7.346,3.9,10.816,4.352c7.045,0.688,13.566-0.653,19.792-2.76c6.186-2.183,12.147-5.262,17.148-9.911     c4.924-4.53,9.161-11.02,9.374-18.385c0.378-7.298-2.601-13.962-6.352-19.275c-3.791-5.318-8.192-10.146-14.019-13.721     c-5.669-3.625-12.941-5.334-19.698-4.165c-6.745,1.109-12.799,4.191-17.907,8.015c-5.132,3.835-9.783,8.16-13.932,12.848     c-8.379,9.326-15.328,19.639-21.802,30.154c-12.715,21.2-23.308,43.437-32.423,66.342c-0.376,0.945,0.085,2.016,1.03,2.392     c0.935,0.372,1.993-0.075,2.38-0.999L2730.604,734.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.67,
      fill: "#91B3FA"
    },
    d: "M2700.797,758.544c0,0-20.607,185.913,52.145,196.144     C2825.695,964.919,2820.05,858.251,2700.797,758.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.67,
      fill: "#91B3FA"
    },
    d: "M2700.797,758.544c0,0-130.856,133.66-184.838,83.825     C2461.978,792.534,2548.117,729.367,2700.797,758.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.67,
      fill: "#91B3FA"
    },
    d: "M2689.7,765.239c0,0-175.808,63.874-202.909-4.413     C2459.689,692.539,2564.68,672.867,2689.7,765.239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.67,
      fill: "#91B3FA"
    },
    d: "M2707.912,773.87c0,0,61.871,176.523,131.886,154.265     C2909.813,905.877,2858.566,812.155,2707.912,773.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.78,
      fill: "#FFFFFF"
    },
    d: "M2751.934,942.976c0.567,0.268,1.198,0.421,1.865,0.422     c16.573,0.038,27.781-5.185,33.308-15.523c16.24-30.379-26.426-94.554-28.25-97.271c-1.356-2.011-4.073-2.544-6.083-1.197     c-2.009,1.35-2.544,4.073-1.197,6.083c11.608,17.3,39.23,66.879,27.798,88.256c-3.88,7.253-12.478,10.917-25.556,10.885     c-2.42-0.006-4.388,1.953-4.394,4.374C2749.421,940.757,2750.449,942.272,2751.934,942.976z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008848545341925847650000018234417390511229608_",
    gradientUnits: "userSpaceOnUse",
    x1: 1309.3258,
    y1: 98.4184,
    x2: 1561.0079,
    y2: 98.4184,
    gradientTransform: "matrix(-0.9036 -0.4283 -0.4283 0.9036 3932.531 1216.7393)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008848545341925847650000018234417390511229608_)"
    },
    d: "M2697.331,765.858     c0,0-62.072-96.267-98.526-113.535c-39.292-18.613-99.2-1.249-128.621,9.455c-5.75,2.092-5.41,10.281,0.46,12.004     C2537.845,693.508,2615.586,727.058,2697.331,765.858z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102525559662075149290000013692359459611912613_",
    gradientUnits: "userSpaceOnUse",
    x1: 1064.6694,
    y1: 98.4067,
    x2: 1316.3517,
    y2: 98.4067,
    gradientTransform: "matrix(-0.9036 -0.4283 -0.4283 0.9036 3932.531 1216.7393)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102525559662075149290000013692359459611912613_)"
    },
    d: "M2690.982,762.849     c0,0,113.814-12.905,150.26,4.378c39.284,18.629,63.775,75.994,74.117,105.544c2.021,5.775-4.532,10.697-9.583,7.244     C2847.961,840.489,2772.771,801.556,2690.982,762.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M2891.837,852.447c1.11,0.526,2.434,0.586,3.649,0.05     c2.214-0.978,3.217-3.564,2.24-5.78c-1.575-3.572-39.293-87.372-102.007-81.684c-2.411,0.219-4.187,2.349-3.969,4.762     c0.219,2.411,2.348,4.189,4.762,3.969c56.501-5.128,92.832,75.673,93.194,76.493     C2890.149,851.258,2890.921,852.012,2891.837,852.447z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124881925476453725760000011084813559549173380_",
    gradientUnits: "userSpaceOnUse",
    x1: 2417.679,
    y1: 1988.2322,
    x2: 2699.9934,
    y2: 1988.2322
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124881925476453725760000011084813559549173380_)"
    },
    d: "M2435.581,2744.092l-17.9-1141.914    c-0.196-12.528,11.886-22.772,26.859-22.772h0c24.216,0,43.848-16.428,43.848-36.692v-278.928    c0-17.757,17.575-31.984,38.784-31.395l96.577,2.684c23.774,0.661,42.767,16.785,43.213,36.687l33.032,1472.331H2435.581z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144337330105203688010000005951905898435064459_",
    gradientUnits: "userSpaceOnUse",
    x1: 4062.658,
    y1: 2149.0313,
    x2: 4185.6392,
    y2: 2474.9314,
    gradientTransform: "matrix(1 0 0 1 -1327.0549 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144337330105203688010000005951905898435064459_)"
    },
    d: "M2703.449,2169.611l0.397,12.497      c38.434,53.502,73.382,39.851,97.458,23.798c-14.489-36.032-17.061-40.015-28.623-52.539      C2729.226,2184.97,2703.449,2169.611,2703.449,2169.611z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072269621146104432520000013924533826299579569_",
    gradientUnits: "userSpaceOnUse",
    x1: 3555.626,
    y1: 270.8921,
    x2: 3319.957,
    y2: 863.4306
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072269621146104432520000013924533826299579569_)"
    },
    d: "M2878.574,2110.898l-67.629-105.734      c-4.436,59.641-15.011,115.5-38.264,148.203c11.562,12.524,14.134,16.507,28.623,52.539      C2861.388,2165.844,2878.574,2110.898,2878.574,2110.898z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120527074252254126190000011407378657911191440_",
    gradientUnits: "userSpaceOnUse",
    x1: 4706.9854,
    y1: 2969.0347,
    x2: 4851.7778,
    y2: 2969.0347,
    gradientTransform: "matrix(-1 0 0 1 7706.3877 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120527074252254126190000011407378657911191440_)"
    },
    d: "M2944.967,2998.228     c-33.717,1.552-66.352,0.577-88.142-0.543c19.84-14.122,65.547-44.845,103.794-57.077l26.256-1.571     c0,0,8.896,13.531,12.071,44.494C2994.594,2988.959,2981.875,2996.53,2944.967,2998.228z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041282764835578537910000018064448870054487937_",
    gradientUnits: "userSpaceOnUse",
    x1: -5183.1719,
    y1: 2675.5586,
    x2: -5183.1719,
    y2: 2975.2666,
    gradientTransform: "matrix(-1 0 0 1 -2256.166 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041282764835578537910000018064448870054487937_)"
    },
    d: "M2856.553,2997.877     c0.087-0.062,0.184-0.13,0.272-0.193c21.79,1.12,54.426,2.095,88.142,0.543c36.909-1.698,49.627-9.269,53.978-14.698     c0.146,1.426,0.296,2.843,0.417,4.344c0.545,6.795-4.498,12.761-11.295,13.275c-27.613,2.088-96.078,6.816-129.094,5.084     C2854.618,3006.005,2853.002,3000.408,2856.553,2997.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105413790681387999640000016164890791994423975_",
    gradientUnits: "userSpaceOnUse",
    x1: 4452.6338,
    y1: 2969.396,
    x2: 4520.4307,
    y2: 2969.396,
    gradientTransform: "matrix(-1 0 0 1 7706.3877 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105413790681387999640000016164890791994423975_)"
    },
    d: "M3186.116,2989.204     c2.469-15.828,6.428-38.711,9.487-44.561c4.8-9.178,21.229,0,21.229,0s11.534,5.378,16.841,14.343     c3.384,5.714,12.742,21.972,19.083,33.01c0.73,1.269,1.033,2.621,0.995,3.929l-65.785,2.302     C3186.358,2995.646,3185.602,2992.5,3186.116,2989.204z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162316970205326787910000003615001626952279446_",
    gradientUnits: "userSpaceOnUse",
    x1: -5500.9292,
    y1: 2746.158,
    x2: -5470.4507,
    y2: 3066.1853,
    gradientTransform: "matrix(-1 0 0 1 -2256.166 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162316970205326787910000003615001626952279446_)"
    },
    d: "M3253.751,2995.925     c-0.11,3.758-3.088,7.166-7.29,7.282l-46.867,1.29c-4.952,0.136-9.24-2.437-11.628-6.269L3253.751,2995.925z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168803070194251701990000018276211524512473745_",
    gradientUnits: "userSpaceOnUse",
    x1: 4481.3076,
    y1: 2922.657,
    x2: 4525.2979,
    y2: 2922.657,
    gradientTransform: "matrix(-1 0 0 1 7706.3877 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168803070194251701990000018276211524512473745_)"
    },
    d: "M3181.09,2892.034     c0.568,1.899,9.068,43.107,12.79,61.193c1.029,4.999,5.531,8.508,10.628,8.253c2.784-0.139,6.022-0.389,9.419-0.829     c6.026-0.78,10.614-5.812,10.845-11.883c0.603-15.842,0.9-46.26-4.917-58.047     C3211.83,2874.462,3181.09,2892.034,3181.09,2892.034z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039135467395947505390000009580136244466514340_",
    gradientUnits: "userSpaceOnUse",
    x1: 4714.3501,
    y1: 2919.7776,
    x2: 4751.0142,
    y2: 2919.7776,
    gradientTransform: "matrix(-1 0 0 1 7706.3877 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039135467395947505390000009580136244466514340_)"
    },
    d: "M2992.038,2903.833     c-3.646-0.116,1.454,18.824-4.061,37.44c-1.244,4.198-4.385,7.495-8.763,7.551c-2.838,0.036-6.201-0.018-9.615-0.292     c-5.135-0.412-9.261-4.396-9.738-9.525l-4.487-48.285L2992.038,2903.833z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078729624142040157480000002042198010956941721_",
    gradientUnits: "userSpaceOnUse",
    x1: 3111.4058,
    y1: 2477.1106,
    x2: 3416.7966,
    y2: 1496.8429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078729624142040157480000002042198010956941721_)"
    },
    d: "M2890.058,2390.559     c1.628,7.921,59.065,342.942,62.55,516.299c0.059,2.906,2.198,5.344,5.076,5.745c7.292,1.017,21.492,2.324,35.261-0.23     c1.885-0.35,3.307-1.902,3.425-3.816c2.008-32.306,18.152-305.448-1.62-434.029c0,0,163.313,343.715,188.068,438.49     c0.603,2.306,2.719,3.857,5.099,3.731c6.995-0.369,21.54-1.627,33.089-5.878c4.14-1.524,6.498-5.875,5.453-10.16     c-13.831-56.719-110.761-447.498-176.573-533.597L2890.058,2390.559z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116212512787969189610000005700498557210658443_",
    gradientUnits: "userSpaceOnUse",
    x1: 2983.5684,
    y1: 2464.7324,
    x2: 3032.386,
    y2: 2192.0295
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116212512787969189610000005700498557210658443_)"
    },
    d: "M2994.751,2476.672     c0.541,0,1.082-0.203,1.499-0.611c0.846-0.827,0.861-2.186,0.033-3.031l-21.869-22.363c-0.827-0.848-2.185-0.86-3.031-0.033     c-0.846,0.827-0.861,2.186-0.033,3.031l21.868,22.362C2993.638,2476.457,2994.195,2476.672,2994.751,2476.672z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141452933309973775950000017753527769456890524_",
    gradientUnits: "userSpaceOnUse",
    x1: 2739.5295,
    y1: 2158.0186,
    x2: 3035.8005,
    y2: 2174.8521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141452933309973775950000017753527769456890524_)"
    },
    d: "M2796.705,1971.117     c41.949-10.989,119.34-28.374,180.928-24.525c20.121,1.258,23.926,20.204,24.729,34.354     c9.305,164.057,23.58,301.465,47.526,386.169c-53.825,21.3-107.185,31.179-159.829,23.444     c-39.438-84.474-73.919-181.995-103.38-292.746c0,0-17.284-88.335-0.5-117.778     C2788.794,1975.446,2792.238,1972.287,2796.705,1971.117z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060715610442047220590000012233076765294234522_",
    gradientUnits: "userSpaceOnUse",
    x1: 4823.8159,
    y1: 2008.0858,
    x2: 4841.8784,
    y2: 1896.699,
    gradientTransform: "matrix(-1 0 0 1 7706.3877 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060715610442047220590000012233076765294234522_)"
    },
    d: "M2897.606,1856.195     c0,0,10.592,63.196,13.75,92.422c0.513,4.749-1.971,9.24-6.218,11.427c-11.577,5.96-36.293,15.559-63.224,6.75     c-4.435-1.451-7.343-5.742-7.241-10.407l1.847-84.368L2897.606,1856.195z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005264135182635920100000015588529662784907403_",
    gradientUnits: "userSpaceOnUse",
    x1: 2708.7573,
    y1: 1398.0188,
    x2: 2269.2808,
    y2: 2070.1597,
    gradientTransform: "matrix(0.9633 0.2686 -0.2686 0.9633 568.7578 -681.8088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005264135182635920100000015588529662784907403_)"
    },
    d: "M2642.891,1523      c1.501-0.846,2.032-2.75,1.185-4.251l-4.298-7.624l-0.327,0.185l-25.307-41.05c-0.904-1.467-2.827-1.923-4.294-1.019      l-4.793,2.955c-1.467,0.904-1.923,2.827-1.019,4.294l23.362,37.894c0.93,1.508,0.419,3.486-1.124,4.356l-183.604,103.537      c-1.501,0.847-2.032,2.75-1.185,4.251l4.299,7.623l0.061-0.034l59.664,105.801c0.846,1.501,2.75,2.032,4.251,1.185l4.904-2.766      c1.501-0.847,2.032-2.75,1.185-4.251l-58.13-103.083c-0.846-1.501-0.316-3.404,1.185-4.251L2642.891,1523z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2183.621,
    y: 1481.864,
    transform: "matrix(0.871 -0.4912 0.4912 0.871 -442.5398 1377.3906)",
    style: {
      fill: "#7D97F4"
    },
    width: 436.866,
    height: 99.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168084861889384225240000010106451047890794407_",
    gradientUnits: "userSpaceOnUse",
    x1: 2761.3911,
    y1: 2009.7273,
    x2: 3181.999,
    y2: 1429.2881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168084861889384225240000010106451047890794407_)"
    },
    d: "M2899.9,2473.811l-28.146,14.249      c-0.738,0.374-1.639,0.078-2.012-0.66l-381.865-754.346c-0.374-0.738-0.078-1.639,0.66-2.012l28.146-14.248      c0.738-0.374,1.639-0.078,2.012,0.66l381.866,754.346C2900.933,2472.537,2900.638,2473.438,2899.9,2473.811z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.871 -0.4912 0.4912 0.871 -519.6471 1297.6385)",
    style: {
      fill: "#7D97F4"
    },
    cx: 2211.612,
    cy: 1638.52,
    rx: 18.566,
    ry: 50.049
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.871 -0.4912 0.4912 0.871 -366.3864 1455.8911)",
    style: {
      fill: "#7D97F4"
    },
    cx: 2589.646,
    cy: 1425.752,
    rx: 18.566,
    ry: 50.049
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018206441203800439170000011267022001959917469_",
    gradientUnits: "userSpaceOnUse",
    x1: 1784.0365,
    y1: 17.9491,
    x2: 1916.5811,
    y2: 369.1924,
    gradientTransform: "matrix(0.7526 0.6585 -0.6585 0.7526 1409.2811 924.6944)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018206441203800439170000011267022001959917469_)"
    },
    d: "M2697.297,2171.534     c-2.657-4.034-3.325-9.021-1.902-13.637c2.759-8.946,8.543-22.083,18.197-19.178c14.377,4.326,16.305,39.861,16.305,39.861     l-3.822,22.806l4.8,11.377C2721.374,2208.17,2709.686,2191.742,2697.297,2171.534z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074404920041227380340000005186744712834454173_",
    gradientUnits: "userSpaceOnUse",
    x1: 3056.075,
    y1: 2068.6055,
    x2: 2789.6311,
    y2: 2365.2131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074404920041227380340000005186744712834454173_)"
    },
    d: "M3030.203,2251.813     c5.884-8.247,11.771-17.269,17.586-27.23c57.541-98.552-47.992-249.471-47.992-249.471l-32.164,95.74     c47.551,53.028,27.581,104.194,11.404,146.648c-21.178,55.581-112.776,102.7-112.776,102.7l17.446,21.529     C2883.707,2341.728,2977.876,2325.161,3030.203,2251.813z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052820702230933462540000008919548327464609710_",
    gradientUnits: "userSpaceOnUse",
    x1: 2746.9897,
    y1: 2026.7194,
    x2: 3043.2595,
    y2: 2043.5529
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052820702230933462540000008919548327464609710_)"
    },
    d: "M3066.366,2125.579     c-1.19-76.515-61.96-157.794-73.06-172.097c-0.788-1.015-2.363-0.815-2.894,0.356l-22.779,117.013     c9.673,22.615,7.706,36.839,17.367,57.206c26.135-3.661,50.399-3.845,76.183,1.744     C3063.881,2130.386,3066.409,2128.339,3066.366,2125.579z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145032164166950339620000015388683406474781094_",
    gradientUnits: "userSpaceOnUse",
    x1: 3075.2991,
    y1: 2085.8745,
    x2: 2808.8542,
    y2: 2382.4829
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145032164166950339620000015388683406474781094_)"
    },
    d: "M2866.26,2320.199     c-5.353-2.705-47.276,3.397-40.847,9.166c11.267,10.11,11.76,17.766-0.089,27.229c-5.847,4.669-19.293,11.757-22.963,0.853     c-1.032-3.065-1.17-7.045-4.089-8.439c-2.156-1.03-8.255,6.353-8.618,8.716c-2.04,13.275,8.564,24.32,20.249,28.721     c5.668,2.135,11.709,3.048,17.698,3.947c3.333,0.5,11.645,1.736,12.386,1.414c0.869-0.377,1.385-1.258,2.02-1.964     c2.729-3.03,17.355-15.346,20.535-19.467c1.717-2.225,23.633-29.846,22.517-32.494     C2885.057,2337.876,2870.792,2322.489,2866.26,2320.199z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060717034076121748020000006698657159618600121_",
    gradientUnits: "userSpaceOnUse",
    x1: -7482.2793,
    y1: -3105.7451,
    x2: -7517.3369,
    y2: -3221.373,
    gradientTransform: "matrix(-0.746 -0.6659 -0.6659 0.746 -4843.6182 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060717034076121748020000006698657159618600121_)"
    },
    d: "M2824.259,1788.869      c0,0-33.873,63.763-29.531,89.52c4.342,25.757,46.323,23.907,82.981,2.989l25.617-68.85L2824.259,1788.869z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159428305161128016160000009790967497344922287_",
    gradientUnits: "userSpaceOnUse",
    x1: -7513.9077,
    y1: -3307.209,
    x2: -7484.5825,
    y2: -3139.9463,
    gradientTransform: "matrix(-0.746 -0.6659 -0.6659 0.746 -4843.6182 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159428305161128016160000009790967497344922287_)"
    },
    d: "M2876.089,1847.566      c-1.49-0.66-2.04-2.483-1.147-3.846c2.714-4.146,7.801-12.604,9.424-20.009c0,0,6.089-3.9-15.499-9.067      c-21.588-5.167-53.781-13.188-60.549-31.563c-6.597-17.915,10.737-62.97,38.392-27.071c1.052,1.366,3.114,1.396,4.165,0.029      c4.534-5.901,16.453-18.148,33.001-10.724c15.486,6.949,17.23,18.296,17.018,24.016c-0.063,1.682,1.441,2.99,3.095,2.675      c7.83-1.493,26.618-2.776,35.388,16.498c7.224,15.876,2.529,24.863-1.748,29.258c-1.385,1.424-0.778,3.769,1.122,4.35      c5.146,1.576,11.791,5.939,11.125,17.994c-0.919,16.666-19.553,15.198-24.859,14.439c-0.869-0.125-1.745,0.174-2.334,0.825      c-4.549,5.034-25.045,26.409-47.227,28.985c-1.921,0.223-3.409-1.674-2.78-3.502l9.6-27.906      c0.446-1.296-0.174-2.717-1.427-3.273L2876.089,1847.566z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013891442190110532830000016623495967359460499_",
    gradientUnits: "userSpaceOnUse",
    x1: -7518.1162,
    y1: -3106.2832,
    x2: -7549.6582,
    y2: -3210.3157,
    gradientTransform: "matrix(-0.746 -0.6659 -0.6659 0.746 -4843.6182 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013891442190110532830000016623495967359460499_)"
    },
    d: "M2872.23,1851.526      c0,0,24.118-16.547,25.88-2.612c1.762,13.935-21.719,20.185-33.349,14.99L2872.23,1851.526z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2799.788,3000.444c-74.075,24.744-146.054,24.767-215.458,2.156     c-17.544-5.716-29.427-22.069-29.427-40.521v-339.937c85.288,18.77,174.69,19.724,268.864,0v345.201     C2823.767,2982.397,2814.067,2995.674,2799.788,3000.444z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#7D97F4"
    },
    cx: 2689.335,
    cy: 2619.431,
    rx: 134.432,
    ry: 27.018
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031893311631759398610000015910218627565389445_",
    gradientUnits: "userSpaceOnUse",
    x1: 2693.7986,
    y1: 2783.0249,
    x2: 2739.2488,
    y2: 2446.355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031893311631759398610000015910218627565389445_)"
    },
    d: "M2823.767,2883.892     c-89.622,31.174-179.244,31.173-268.864,0v-135.608c90.428,22.295,180.091,23.428,268.864,0V2883.892z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011019117166201811200000000007343161948697743_",
    gradientUnits: "userSpaceOnUse",
    x1: 2746.2883,
    y1: 2290.8206,
    x2: 2726.0881,
    y2: 2422.1218
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011019117166201811200000000007343161948697743_)"
    },
    d: "M2569.323,2653.042     c2.881,10.764,15.159,18.023,25.979,15.359c7.585-1.868,14.067-7.805,21.878-7.939c8.869-0.152,15.951,7.164,21.123,14.371     c9.396,13.094,16.542,27.797,21.031,43.275c1.495,5.155,2.821,10.626,6.441,14.589c7.748,8.48,22.399,5.766,31.009-1.837     c8.61-7.604,13.289-18.579,19.687-28.12c6.398-9.541,16.225-18.441,27.691-17.746c3.839,0.232,7.558,1.545,11.401,1.708     c8.508,0.359,16.874-5.669,19.225-13.853c0.721-2.51,0.947-5.211,2.243-7.479c3.884-6.793,14.156-7.453,19.472-12.962     c3.369-3.491,4.49-8.574,8.421-12.009c1.487-1.299,11.682-5.514,11.893-6.158c1.794-5.48-3.904-10.431-9.172-12.777     c-30.912-13.763-66.24-0.041-99.751,4.65c-32.915,4.607-64.418-2.902-97.024-2.616     C2592.897,2623.653,2562.615,2627.98,2569.323,2653.042z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#7D97F4"
    },
    cx: 2690.894,
    cy: 2620.202,
    rx: 134.432,
    ry: 27.018
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049204770036903053310000008742230513742886314_",
    gradientUnits: "userSpaceOnUse",
    x1: 2696.9897,
    y1: 2574.5703,
    x2: 2675.803,
    y2: 2674.4507
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000049204770036903053310000008742230513742886314_)"
    },
    cx: 2687.31,
    cy: 2620.202,
    rx: 110.666,
    ry: 16.34
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1224.93,2973.892H498.206c-23.174,0-41.96-18.786-41.96-41.96v-701.688     c0-23.13,18.717-41.898,41.847-41.959l732.536-1.966c23.305-0.063,42.196,18.878,42.072,42.183l-5.812,703.655     C1266.766,2955.242,1248.017,2973.892,1224.93,2973.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1189.319,2240.026l-649.808,4.001c-23.488,0.145-42.422,19.284-42.313,42.773l4.534,590.159     c0.108,23.134,18.668,41.949,41.799,42.371l631.369,11.519c23.581,0.43,43.018-18.39,43.348-41.972l13.905-605.679     C1232.487,2259.349,1213.168,2239.879,1189.319,2240.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M1162.898,2294.758v4.48c0,7.034-5.702,12.737-12.737,12.737H649.487     c-7.034,0-12.737-5.702-12.737-12.737v-4.48c0-7.034,5.702-12.737,12.737-12.737h500.674     C1157.195,2282.021,1162.898,2287.723,1162.898,2294.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M1107.035,2351.107L1107.035,2351.107c-0.361,6.667-5.81,11.924-12.486,12.045     l-437.864,7.98c-7.124,0.13-12.969-5.609-12.969-12.735v-1.04c0-6.956,5.58-12.625,12.535-12.735l437.865-6.94     C1101.499,2337.565,1107.435,2343.732,1107.035,2351.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1151.729,2897.471c-0.148,0-0.292,0-0.437-0.001l-592.238-7.108     c-9.74-0.118-18.838-4.034-25.619-11.029c-6.78-6.993-10.412-16.208-10.229-25.947l15.241-416.743     c0.183-9.589,4.133-18.632,11.12-25.355c6.99-6.724,16.317-10.296,25.869-10.132l591.203,11.506     c19.97,0.389,35.931,16.956,35.58,36.927c-0.003,0.034-0.003,0.068-0.003,0.102l-14.21,412.237     C1187.66,2881.573,1171.425,2897.471,1151.729,2897.471z M574.718,2413.224c-6.291,0-12.231,2.392-16.777,6.766     c-4.664,4.487-7.299,10.52-7.42,16.99l-15.241,416.743c-0.121,6.391,2.302,12.541,6.825,17.206     c4.525,4.667,10.598,7.28,17.099,7.358l592.235,7.108c0.097,0.001,0.194,0.001,0.292,0.001c13.142,0,23.973-10.609,24.206-23.784     l14.212-412.286c0.206-13.304-10.433-24.331-23.743-24.593l-591.203-11.506C575.039,2413.226,574.877,2413.224,574.718,2413.224z      M1196.183,2449.484h0.029H1196.183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1188.509,2493.615H543.522c-3.334,0-6.038-2.703-6.038-6.038s2.703-6.038,6.038-6.038h644.987     c3.334,0,6.037,2.703,6.037,6.038S1191.843,2493.615,1188.509,2493.615z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129906189225050874150000006587212553275986818_",
    gradientUnits: "userSpaceOnUse",
    x1: 942.7189,
    y1: 1020.6496,
    x2: 952.0317,
    y2: 1020.6496
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129906189225050874150000006587212553275986818_)"
    },
    d: "M950.673,1031.877       c-0.64,0.577-1.463,0.958-2.389,1.039c-2.256,0.196-4.245-1.473-4.443-3.732c-0.474-5.48-0.851-11.036-1.117-16.515       c-0.115-2.265,1.636-4.184,3.895-4.296c2.263-0.111,4.186,1.635,4.296,3.898c0.263,5.373,0.633,10.828,1.101,16.205       C952.131,1029.807,951.595,1031.046,950.673,1031.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175316596517392216000000008579424907807204498_",
    gradientUnits: "userSpaceOnUse",
    x1: 943.5659,
    y1: 759.0664,
    x2: 1638.8104,
    y2: 759.0664
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175316596517392216000000008579424907807204498_)"
    },
    d: "M1637.453,648.712       c-1.423,1.284-3.598,1.429-5.195,0.242c-8.893-6.623-18.164-12.976-27.55-18.873c-1.921-1.208-2.495-3.737-1.289-5.656       c1.184-1.937,3.736-2.497,5.653-1.292c9.572,6.017,19.02,12.489,28.087,19.241c1.818,1.354,2.192,3.924,0.838,5.739       C1637.834,648.336,1637.649,648.535,1637.453,648.712z M1561.504,603.531c-1.184,1.068-2.933,1.389-4.472,0.679       c-10.036-4.642-20.412-8.956-30.839-12.82c-2.126-0.79-3.207-3.148-2.42-5.272c0.777-2.131,3.148-3.207,5.269-2.423       c10.628,3.941,21.206,8.337,31.436,13.069c2.055,0.951,2.951,3.39,2,5.446C1562.238,602.729,1561.902,603.172,1561.504,603.531       z M1477.917,574.811c-0.965,0.871-2.323,1.271-3.685,0.951c-10.821-2.531-21.853-4.663-32.787-6.337       c-2.24-0.342-3.775-2.436-3.434-4.676c0.34-2.233,2.429-3.777,4.673-3.434c11.149,1.707,22.391,3.881,33.417,6.46       c2.204,0.515,3.574,2.72,3.059,4.927C1478.963,573.549,1478.516,574.271,1477.917,574.811z M950.415,960.76       c-0.807,0.728-1.904,1.135-3.075,1.043c-2.257-0.181-3.942-2.157-3.761-4.413c0.899-11.249,2.255-22.621,4.03-33.798       c0.354-2.234,2.453-3.761,4.696-3.406c2.236,0.356,3.762,2.459,3.406,4.696c-1.743,10.965-3.073,22.123-3.955,33.158       C951.669,959.127,951.166,960.083,950.415,960.76z M1390.272,563.59c-0.752,0.679-1.756,1.082-2.849,1.055       c-11.071-0.273-22.297-0.103-33.362,0.504c-2.264,0.122-4.195-1.609-4.319-3.872c-0.125-2.267,1.614-4.196,3.869-4.322       c11.283-0.616,22.727-0.787,34.014-0.51c2.265,0.055,4.055,1.935,3.999,4.199       C1391.597,561.818,1391.078,562.863,1390.272,563.59z M966.416,873.83c-1.022,0.922-2.479,1.309-3.899,0.896       c-2.174-0.634-3.422-2.911-2.789-5.085c3.17-10.882,6.797-21.744,10.776-32.288c0.794-2.125,3.166-3.191,5.284-2.389       c2.121,0.8,3.19,3.164,2.389,5.284c-3.904,10.347-7.462,21.007-10.575,31.686C967.384,872.693,966.962,873.338,966.416,873.83z        M1302.212,570.578c-0.544,0.491-1.227,0.843-2.002,0.986c-10.864,2.001-21.82,4.468-32.567,7.335       c-2.185,0.586-4.432-0.716-5.019-2.905c-0.581-2.19,0.72-4.437,2.908-5.019c10.948-2.924,22.118-5.438,33.193-7.478       c2.229-0.409,4.365,1.063,4.777,3.291C1303.769,568.24,1303.236,569.654,1302.212,570.578z M999.648,791.935       c-1.245,1.123-3.106,1.41-4.671,0.578c-2.002-1.064-2.76-3.546-1.7-5.55c5.309-9.985,11.076-19.881,17.147-29.41       c1.21-1.906,3.75-2.472,5.661-1.256c1.91,1.217,2.473,3.751,1.256,5.664c-5.953,9.346-11.611,19.054-16.82,28.851       C1000.29,791.247,999.993,791.623,999.648,791.935z M1217.432,595.436c-0.344,0.31-0.743,0.567-1.197,0.751       c-10.256,4.193-20.483,8.84-30.397,13.82c-2.024,1.018-4.488,0.203-5.507-1.823c-1.016-2.023-0.199-4.487,1.826-5.504       c10.1-5.077,20.524-9.815,30.979-14.085c2.097-0.856,4.488,0.147,5.345,2.245       C1219.153,592.485,1218.679,594.31,1217.432,595.436z M1139.469,637.011c-0.144,0.13-0.298,0.252-0.464,0.365       c-9.191,6.172-18.262,12.803-26.969,19.698c-1.775,1.408-4.355,1.108-5.764-0.669c-1.406-1.779-1.016-4.349,0.669-5.761       c8.874-7.029,18.123-13.783,27.488-20.08c1.881-1.26,4.428-0.764,5.691,1.118       C1141.274,633.397,1140.958,635.667,1139.469,637.011z M1048.946,718.591c-1.491,1.345-3.784,1.423-5.372,0.099       c-1.736-1.449-1.972-4.036-0.521-5.777c7.241-8.68,14.917-17.181,22.815-25.261c1.648-1.59,4.18-1.651,5.802-0.066       c1.619,1.582,1.649,4.177,0.066,5.799c-7.748,7.93-15.28,16.268-22.382,24.785       C1049.226,718.321,1049.09,718.46,1048.946,718.591z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112629299375984296190000011052233716162931859_",
    gradientUnits: "userSpaceOnUse",
    x1: 1672.4844,
    y1: 687.0544,
    x2: 1692.2585,
    y2: 687.0544
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112629299375984296190000011052233716162931859_)"
    },
    d: "M1690.904,695.898       c-1.639,1.478-4.167,1.397-5.707-0.208c-3.725-3.884-7.58-7.753-11.46-11.503c-1.629-1.573-1.674-4.17-0.1-5.8       c1.611-1.572,4.173-1.672,5.8-0.097c3.953,3.819,7.885,7.765,11.682,11.724c1.566,1.634,1.513,4.23-0.121,5.801       C1690.966,695.842,1690.935,695.87,1690.904,695.898z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056415011886835431860000008078606817166878125_",
    gradientUnits: "userSpaceOnUse",
    x1: 1804.0203,
    y1: 998.7191,
    x2: 1812.5107,
    y2: 998.7191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056415011886835431860000008078606817166878125_)"
    },
    d: "M1810.868,1009.964       c-0.764,0.69-1.787,1.095-2.897,1.055c-2.263-0.084-4.032-1.988-3.947-4.25c0.199-5.424,0.295-10.888,0.282-16.244       c0.001-2.256,1.834-4.099,4.094-4.109c2.265-0.004,4.106,1.83,4.112,4.097c0.009,5.457-0.089,11.026-0.292,16.556       C1812.177,1008.222,1811.662,1009.247,1810.868,1009.964z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044157936648142522480000003064929579227476641_",
    gradientUnits: "userSpaceOnUse",
    x1: 1099.4854,
    y1: 1241.5242,
    x2: 1806.869,
    y2: 1241.5242
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044157936648142522480000003064929579227476641_)"
    },
    d: "M1669.122,1314.24l-2.769,2.477       c-1.698,1.5-4.29,1.341-5.79-0.354c-1.491-1.686-1.344-4.258,0.325-5.763c0.009-0.008,0.019-0.018,0.03-0.027l2.709-2.423       c7.192-6.489,14.264-13.322,21.017-20.31c1.623-1.589,4.172-1.671,5.8-0.097c1.627,1.574,1.673,4.171,0.1,5.801       C1683.658,1300.661,1676.453,1307.626,1669.122,1314.24z M1623.923,1349.856c-0.135,0.122-0.28,0.237-0.433,0.342       c-9.165,6.279-18.695,12.287-28.328,17.86c-1.961,1.133-4.471,0.462-5.603-1.499c-1.136-1.964-0.451-4.459,1.496-5.606       c9.452-5.464,18.808-11.358,27.797-17.521c1.868-1.281,4.423-0.802,5.702,1.065       C1625.728,1346.21,1625.425,1348.501,1623.923,1349.856z M1725.277,1252.711c-1.426,1.287-3.606,1.43-5.201,0.236       c-1.815-1.357-2.186-3.93-0.828-5.743c6.545-8.743,12.82-17.846,18.656-27.049c1.208-1.926,3.743-2.482,5.659-1.27       c1.914,1.213,2.48,3.745,1.267,5.659c-5.946,9.384-12.343,18.661-19.015,27.578       C1725.653,1252.339,1725.471,1252.535,1725.277,1252.711z M1547.625,1391.579c-0.332,0.299-0.717,0.55-1.152,0.732       c-10.263,4.339-20.8,8.322-31.321,11.842c-2.147,0.718-4.472-0.443-5.19-2.589c-0.721-2.144,0.433-4.48,2.585-5.192       c10.322-3.454,20.663-7.362,30.735-11.616c2.084-0.882,4.493,0.095,5.374,2.181       C1549.354,1388.59,1548.886,1390.442,1547.625,1391.579z M1770.042,1178.143c-1.189,1.073-2.953,1.391-4.494,0.667       c-2.049-0.962-2.93-3.404-1.967-5.454c4.62-9.833,8.932-20.012,12.812-30.262c0.8-2.119,3.172-3.185,5.29-2.383       c2.119,0.802,3.184,3.17,2.383,5.29c-3.957,10.443-8.35,20.821-13.06,30.842       C1770.767,1177.353,1770.434,1177.788,1770.042,1178.143z M1464.534,1417.195c-0.529,0.478-1.188,0.824-1.938,0.972       c-10.888,2.184-22.009,3.969-33.054,5.309c-2.248,0.274-4.292-1.328-4.564-3.575c-0.277-2.253,1.327-4.288,3.578-4.566       c10.835-1.316,21.745-3.068,32.428-5.207c2.222-0.446,4.382,0.994,4.828,3.213       C1466.106,1414.811,1465.573,1416.258,1464.534,1417.195z M1798.912,1096.098c-0.974,0.879-2.349,1.277-3.718,0.943       c-2.2-0.534-3.553-2.755-3.018-4.954c2.578-10.606,4.778-21.444,6.542-32.207c0.369-2.237,2.474-3.748,4.713-3.384       c2.233,0.364,3.75,2.476,3.384,4.71c-1.799,10.966-4.041,22.01-6.667,32.816       C1799.945,1094.854,1799.502,1095.566,1798.912,1096.098z M1378.007,1425.552c-0.732,0.66-1.704,1.062-2.769,1.053       c-11.087-0.058-22.343-0.557-33.453-1.48c-2.256-0.187-3.934-2.169-3.747-4.425c0.183-2.258,2.167-3.94,4.426-3.75       c10.9,0.906,21.943,1.393,32.821,1.456c2.265,0.012,4.089,1.857,4.078,4.122       C1379.357,1423.73,1378.834,1424.806,1378.007,1425.552z M1291.561,1416.264c-0.941,0.849-2.261,1.252-3.598,0.969       c-8.554-1.804-17.19-3.895-25.668-6.221c-2.283-0.626-4.559-1.271-6.819-1.929c-2.176-0.637-3.425-2.914-2.787-5.086       c0.631-2.177,2.914-3.422,5.083-2.79c2.221,0.65,4.452,1.281,6.691,1.893c8.323,2.283,16.797,4.336,25.194,6.109       c2.217,0.466,3.632,2.641,3.166,4.858C1292.637,1414.949,1292.181,1415.705,1291.561,1416.264z M1208.672,1389.937       c-1.155,1.042-2.854,1.378-4.376,0.722c-10.208-4.412-20.373-9.277-30.213-14.464c-2.003-1.058-2.773-3.54-1.715-5.542       c1.054-2.004,3.537-2.771,5.539-1.718c9.653,5.09,19.627,9.864,29.643,14.191c2.078,0.898,3.036,3.314,2.138,5.392       C1209.446,1389.076,1209.095,1389.554,1208.672,1389.937z M1132.745,1347.529c-1.387,1.251-3.503,1.429-5.098,0.311       c-9.101-6.377-18.073-13.198-26.668-20.273c-1.747-1.44-1.998-4.024-0.56-5.774c1.445-1.708,4.026-1.998,5.774-0.56       c8.432,6.942,17.235,13.635,26.16,19.889c1.855,1.299,2.306,3.859,1.005,5.712       C1133.179,1347.095,1132.971,1347.325,1132.745,1347.529z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036936237036048494140000017609137696481128092_",
    gradientUnits: "userSpaceOnUse",
    x1: 1049.0369,
    y1: 1281.4178,
    x2: 1068.2032,
    y2: 1281.4178
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036936237036048494140000017609137696481128092_)"
    },
    d: "M1066.847,1290.535       c-1.651,1.489-4.198,1.392-5.728-0.232c-3.75-3.974-7.493-8.096-11.13-12.255c-1.49-1.709-1.133-4.297,0.388-5.788       c1.706-1.491,4.299-1.316,5.788,0.388c3.566,4.081,7.24,8.126,10.917,12.026c1.557,1.648,1.481,4.242-0.166,5.798       C1066.893,1290.493,1066.871,1290.513,1066.847,1290.535z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122685102731476112520000006709339898903613056_",
    gradientUnits: "userSpaceOnUse",
    x1: 1050.171,
    y1: 988.193,
    x2: 1706.4615,
    y2: 988.193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122685102731476112520000006709339898903613056_)"
    },
    d: "M1102.768,1176.387       c1.03,1.951,3.185,3.034,5.366,2.697l62.208-9.643c19.294,22.182,42.264,41.446,68.373,56.732l2.043,62.877       c0.071,2.206,1.535,4.122,3.642,4.774l72.146,22.284c2.109,0.65,4.398-0.108,5.701-1.887l37.147-50.773       c30.181,2.099,60.013-0.855,88.455-8.293l45.936,43.044c1.61,1.508,4,1.83,5.951,0.8l66.772-35.258       c1.952-1.031,3.035-3.186,2.696-5.366l-9.641-62.208c22.181-19.294,41.445-42.264,56.731-68.373l62.878-2.043       c2.205-0.072,4.122-1.534,4.774-3.643l22.284-72.147c0.651-2.108-0.107-4.398-1.888-5.7l-50.774-37.147       c2.101-30.182-0.853-60.013-8.292-88.456l43.045-45.936c1.508-1.609,1.829-4,0.799-5.951L1653.864,800       c-1.03-1.953-3.185-3.034-5.366-2.696l-62.208,9.642c-19.293-22.182-42.263-41.446-68.372-56.732l-2.043-62.879       c-0.072-2.204-1.534-4.122-3.642-4.773l-72.148-22.284c-2.108-0.651-4.398,0.107-5.7,1.888l-37.146,50.773       c-30.182-2.101-60.014,0.854-88.457,8.292l-45.935-43.043c-1.609-1.51-4.001-1.831-5.952-0.8l-66.772,35.258       c-1.951,1.03-3.035,3.185-2.697,5.366l9.641,62.208c-22.182,19.294-41.445,42.264-56.731,68.373l-62.879,2.044       c-2.203,0.071-4.121,1.534-4.772,3.643l-22.284,72.146c-0.651,2.108,0.107,4.397,1.887,5.701l50.773,37.146       c-2.1,30.181,0.855,60.013,8.292,88.455l-43.044,45.936c-1.509,1.61-1.83,4-0.8,5.952L1102.768,1176.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M1427.353,1042.543c-0.018,0.016-0.034,0.031-0.052,0.047       c-14.531,13.083-33.285,19.726-52.81,18.704c-19.526-1.022-37.485-9.585-50.567-24.115       c-13.086-14.531-19.729-33.288-18.705-52.812c2.106-40.311,36.621-71.385,76.925-69.274       c19.525,1.022,37.485,9.586,50.567,24.115c13.086,14.531,19.729,33.288,18.706,52.812       C1450.394,1011.52,1441.851,1029.462,1427.353,1042.543z M1337.523,942.98c-12.062,10.883-19.167,25.806-20.019,42.03       c-0.851,16.245,4.674,31.846,15.56,43.933c10.884,12.088,25.826,19.214,42.068,20.065c16.243,0.849,31.846-4.677,43.934-15.562       c0.013-0.012,0.029-0.027,0.043-0.039c12.062-10.883,19.168-25.806,20.019-42.03c0.851-16.245-4.674-31.846-15.56-43.932       c-10.884-12.088-25.827-19.214-42.069-20.065c-16.243-0.849-31.846,4.677-43.934,15.561       C1337.553,942.953,1337.536,942.968,1337.523,942.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M1506.047,1126.937c-47.702,43.043-116.241,60.655-181.963,40.357       c-12.838-3.965-25.238-9.285-36.851-15.812l6.028-10.725c10.856,6.098,22.449,11.073,34.453,14.781       c72.867,22.504,149.462-4.847,192.821-62.599c0.082-0.107,0.161-0.216,0.243-0.322c0.084-0.113,0.164-0.218,0.248-0.332       c11.606-15.601,20.792-33.394,26.849-53.004c13.879-44.927,9.43-92.572-12.526-134.155       c-6.96-13.179-15.413-25.248-25.144-36.031c-20.976-23.24-47.892-40.495-78.582-49.975       c-92.75-28.647-191.519,23.505-220.164,116.254c-9.419,30.497-10.402,62.911-2.84,93.732l-11.951,2.928       c-8.092-32.981-7.041-67.663,3.033-100.294c30.655-99.224,136.319-155.028,235.553-124.376       c32.838,10.142,61.633,28.604,84.074,53.468c10.412,11.537,19.456,24.449,26.899,38.547       c23.494,44.489,28.255,95.467,13.407,143.535C1549.284,1076.426,1530.372,1104.991,1506.047,1126.937z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149381062920804404710000005408406211824378754_",
    gradientUnits: "userSpaceOnUse",
    x1: 1796.6567,
    y1: 1102.527,
    x2: 1815.2303,
    y2: 1102.527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149381062920804404710000005408406211824378754_)"
    },
    d: "M1798.047,1106.997       c-0.553-0.377-0.992-0.929-1.222-1.613c-0.562-1.667,0.334-3.476,2.001-4.037c4.077-1.375,8.248-2.634,12.397-3.738       c1.699-0.454,3.443,0.558,3.899,2.259c0.454,1.699-0.559,3.446-2.259,3.899c-4.015,1.071-8.053,2.289-11.999,3.617       C1799.878,1107.718,1798.846,1107.542,1798.047,1106.997z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037692758931044045640000005720572067711636361_",
    gradientUnits: "userSpaceOnUse",
    x1: 1851.6558,
    y1: 1221.1515,
    x2: 2064.7073,
    y2: 1221.1515
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037692758931044045640000005720572067711636361_)"
    },
    d: "M2052.282,1350.928       c-1.11-0.757-1.66-2.164-1.266-3.523c2.434-8.368,4.322-16.992,5.611-25.632c0.262-1.743,1.882-2.943,3.624-2.682       c1.736,0.26,2.941,1.884,2.682,3.622c-1.332,8.923-3.282,17.829-5.795,26.471c-0.492,1.691-2.26,2.663-3.951,2.17       C2052.855,1351.258,2052.552,1351.112,2052.282,1350.928z M2059.726,1281.628c-0.779-0.531-1.317-1.402-1.386-2.418       c-0.591-8.724-1.779-17.471-3.528-25.998c-0.353-1.725,0.757-3.409,2.483-3.762c1.723-0.354,3.408,0.76,3.762,2.482       c1.807,8.803,3.033,17.837,3.644,26.845c0.119,1.757-1.208,3.278-2.964,3.396       C2060.993,1282.225,2060.295,1282.016,2059.726,1281.628z M1853.05,1096.815c-0.805-0.549-1.347-1.458-1.391-2.504       c-0.074-1.757,1.294-3.243,3.051-3.314c4.796-0.2,9.682-0.228,14.529-0.088c4.188,0.12,8.414,0.376,12.561,0.755       c1.76,0.156,3.045,1.711,2.883,3.465c-0.159,1.752-1.709,3.042-3.463,2.882c-4.018-0.366-8.11-0.613-12.166-0.731       c-4.697-0.136-9.434-0.108-14.077,0.083C1854.264,1097.394,1853.596,1097.188,1853.05,1096.815z M2042.845,1214.029       c-0.469-0.32-0.859-0.77-1.11-1.326c-3.572-7.95-7.718-15.742-12.331-23.155c-0.928-1.495-0.471-3.459,1.025-4.39       c1.498-0.934,3.455-0.47,4.39,1.023c4.76,7.657,9.045,15.701,12.732,23.91c0.721,1.606,0.004,3.491-1.601,4.213       C2044.9,1214.775,2043.731,1214.633,2042.845,1214.029z M1922.134,1106.058c-1.135-0.774-1.678-2.229-1.239-3.602       c0.536-1.676,2.331-2.604,4.008-2.067c8.573,2.745,17.05,6.102,25.193,9.982c1.588,0.748,2.263,2.658,1.507,4.248       c-0.758,1.589-2.66,2.262-4.248,1.507c-7.886-3.757-16.094-7.01-24.396-9.664       C1922.66,1106.364,1922.382,1106.227,1922.134,1106.058z M2003.603,1156.449c-0.172-0.117-0.335-0.251-0.487-0.407       c-6.106-6.246-12.683-12.136-19.552-17.504c-1.387-1.085-1.632-3.087-0.548-4.475c1.082-1.383,3.071-1.557,4.474-0.548       c7.091,5.542,13.882,11.623,20.186,18.072c1.23,1.26,1.208,3.276-0.052,4.508       C2006.519,1157.172,2004.832,1157.287,2003.603,1156.449z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107560469032359416830000008368808216550742421_",
    gradientUnits: "userSpaceOnUse",
    x1: 2027.7236,
    y1: 1393.9036,
    x2: 2040.6191,
    y2: 1393.9036
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107560469032359416830000008368808216550742421_)"
    },
    d: "M2029.114,1402.014       c-1.417-0.966-1.819-2.89-0.89-4.347c2.242-3.515,4.395-7.14,6.4-10.78c0.849-1.542,2.788-2.103,4.329-1.252       c1.616,0.804,2.103,2.786,1.255,4.328c-2.07,3.757-4.294,7.503-6.611,11.133c-0.945,1.484-2.916,1.918-4.402,0.973       C2029.168,1402.051,2029.141,1402.033,2029.114,1402.014z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055670677043575374690000010439135848342071205_",
    gradientUnits: "userSpaceOnUse",
    x1: 1895.0046,
    y1: 1486.9568,
    x2: 1913.8477,
    y2: 1486.9568
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055670677043575374690000010439135848342071205_)"
    },
    d: "M1896.396,1490.904       c-0.684-0.466-1.187-1.198-1.342-2.079c-0.308-1.732,0.848-3.385,2.582-3.694c4.103-0.725,8.231-1.595,12.267-2.583       c1.708-0.422,3.435,0.631,3.852,2.34c0.419,1.709-0.627,3.433-2.337,3.854c-4.168,1.019-8.432,1.917-12.672,2.669       C1897.894,1491.56,1897.06,1491.356,1896.396,1490.904z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146499390181852851160000012671024768787141527_",
    gradientUnits: "userSpaceOnUse",
    x1: 1661.4932,
    y1: 1359.3658,
    x2: 1858.892,
    y2: 1359.3658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146499390181852851160000012671024768787141527_)"
    },
    d: "M1763.26,1467.984       c-1.359-0.927-1.801-2.757-0.97-4.21c0.872-1.53,2.819-2.063,4.349-1.19c7.451,4.255,15.264,8.045,23.218,11.271       c1.648,0.66,2.415,2.525,1.756,4.151c-0.662,1.632-2.521,2.418-4.153,1.757c-8.215-3.333-16.285-7.249-23.982-11.642       C1763.403,1468.078,1763.329,1468.031,1763.26,1467.984z M1728.75,1443.062c-0.118-0.081-0.231-0.169-0.34-0.266       c-6.589-5.928-12.847-12.349-18.6-19.085c-1.143-1.337-0.984-3.35,0.355-4.493c1.34-1.143,3.355-0.979,4.493,0.355       c5.57,6.525,11.634,12.742,18.016,18.483c1.308,1.178,1.416,3.192,0.238,4.502       C1731.831,1443.757,1730.047,1443.946,1728.75,1443.062z M1827.813,1491.097c-0.998-0.68-1.564-1.902-1.347-3.171       c0.296-1.735,1.943-2.902,3.678-2.604c8.442,1.442,17.082,2.338,25.682,2.668c1.761,0.056,3.131,1.543,3.063,3.306       c-0.067,1.758-1.547,3.13-3.306,3.061c-8.877-0.338-17.798-1.263-26.513-2.753       C1828.605,1491.524,1828.18,1491.347,1827.813,1491.097z M1686.396,1389.142c-0.409-0.279-0.759-0.657-1.011-1.122       c-4.199-7.82-7.91-15.982-11.027-24.262c-0.621-1.648,0.213-3.486,1.86-4.107c1.647-0.617,3.487,0.211,4.105,1.861       c3.018,8.017,6.611,15.921,10.679,23.49c0.832,1.55,0.249,3.485-1.3,4.316       C1688.617,1389.9,1687.347,1389.791,1686.396,1389.142z M1664.931,1324.038c-0.712-0.486-1.226-1.258-1.359-2.177       c-1.269-8.742-1.968-17.679-2.078-26.565c-0.021-1.759,1.388-3.205,3.148-3.225c1.761-0.02,3.203,1.389,3.225,3.148       c0.107,8.605,0.782,17.262,2.011,25.728c0.254,1.74-0.954,3.358-2.695,3.61       C1666.359,1324.677,1665.566,1324.471,1664.931,1324.038z M1666.866,1255.5c-1.028-0.701-1.594-1.972-1.33-3.268       c1.767-8.695,4.133-17.347,7.032-25.715c0.577-1.664,2.391-2.543,4.055-1.967c1.67,0.57,2.544,2.394,1.969,4.055       c-2.808,8.102-5.098,16.478-6.808,24.895c-0.352,1.726-2.034,2.84-3.758,2.49       C1667.597,1255.9,1667.206,1255.731,1666.866,1255.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180366426073656267430000003319725362327578807_",
    gradientUnits: "userSpaceOnUse",
    x1: 1690.6676,
    y1: 1183.6201,
    x2: 1704.0488,
    y2: 1183.6201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180366426073656267430000003319725362327578807_)"
    },
    d: "M1692.057,1191.572       c-1.396-0.952-1.811-2.843-0.918-4.299c2.251-3.667,4.646-7.304,7.118-10.81c1.005-1.424,2.964-1.776,4.399-0.798       c0.014,0.01,0.028,0.019,0.042,0.029c1.438,1.015,1.782,3.005,0.769,4.442c-2.395,3.396-4.717,6.921-6.895,10.472       c-0.921,1.5-2.884,1.97-4.384,1.049C1692.143,1191.631,1692.099,1191.601,1692.057,1191.572z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140713756468375044780000018304730001941198252_",
    gradientUnits: "userSpaceOnUse",
    x1: 1711.2754,
    y1: 1292.7335,
    x2: 2018.5071,
    y2: 1292.7335
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140713756468375044780000018304730001941198252_)"
    },
    d: "M1750.599,1189.787       c-0.762,0.674-1.012,1.757-0.624,2.697l11.09,26.817c-7.836,11.057-13.966,23.443-17.971,36.802l-27.943,7.759       c-0.98,0.272-1.679,1.136-1.742,2.151l-2.13,34.743c-0.062,1.015,0.527,1.958,1.466,2.348l26.787,11.114       c2.345,13.748,6.915,26.79,13.342,38.721l-14.282,25.262c-0.501,0.885-0.384,1.991,0.289,2.753l23.061,26.073       c0.674,0.762,1.757,1.013,2.697,0.624l26.816-11.09c11.057,7.836,23.443,13.965,36.802,17.97l7.759,27.943       c0.272,0.98,1.136,1.679,2.151,1.742l34.744,2.129c1.015,0.062,1.958-0.526,2.348-1.466l11.113-26.787       c13.748-2.344,26.79-6.914,38.721-13.342l25.262,14.282c0.885,0.5,1.991,0.384,2.753-0.29l26.072-23.061       c0.763-0.674,1.012-1.757,0.624-2.697l-11.09-26.816c7.836-11.057,13.966-23.443,17.971-36.802l27.944-7.759       c0.979-0.272,1.679-1.136,1.742-2.151l2.129-34.744c0.063-1.015-0.526-1.958-1.466-2.348l-26.787-11.114       c-2.344-13.748-6.915-26.79-13.342-38.721l14.281-25.261c0.501-0.885,0.385-1.992-0.289-2.753l-23.062-26.073       c-0.674-0.762-1.757-1.013-2.697-0.624l-26.816,11.09c-11.057-7.836-23.443-13.965-36.802-17.97l-7.759-27.944       c-0.272-0.979-1.136-1.679-2.151-1.741l-34.743-2.13c-1.015-0.062-1.958,0.526-2.348,1.466l-11.113,26.787       c-13.748,2.344-26.79,6.915-38.721,13.342l-25.262-14.282c-0.885-0.501-1.991-0.384-2.753,0.29L1750.599,1189.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M1844.787,1322.221c-0.009-0.006-0.018-0.012-0.028-0.019       c-7.872-5.375-13.177-13.497-14.94-22.865c-1.764-9.369,0.227-18.865,5.603-26.734c5.378-7.872,13.499-13.18,22.866-14.941       c19.337-3.64,38.034,9.131,41.674,28.47c1.764,9.369-0.227,18.865-5.603,26.734c-5.378,7.871-13.5,13.179-22.868,14.94       C1862.136,1329.566,1852.654,1327.584,1844.787,1322.221z M1879.603,1271.157c-5.522-3.765-12.474-5.431-19.546-4.101       c-6.858,1.291-12.802,5.175-16.738,10.937c-3.938,5.765-5.396,12.715-4.105,19.573c1.291,6.858,5.177,12.804,10.938,16.74       c0.006,0.005,0.014,0.01,0.021,0.014c5.759,3.926,12.701,5.378,19.55,4.089c6.858-1.291,12.804-5.174,16.74-10.937       c3.938-5.764,5.396-12.715,4.105-19.573C1889.235,1280.813,1885.137,1274.931,1879.603,1271.157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M1815.552,1366.658c-25.022-17.056-40.717-46.486-38.732-78.843       c0.342-5.602,1.211-11.161,2.585-16.56c0.176-0.694,0.361-1.385,0.555-2.074l9.204,2.584       c-1.512,5.392-2.455,10.987-2.802,16.635l0,0c-0.383,6.259-0.024,12.396,0.997,18.324c0.003,0.017,0.007,0.031,0.01,0.048       c0.003,0.029,0.01,0.06,0.015,0.089c4.599,26.377,22.366,48.624,46.64,59.108c6.283,2.721,13,4.655,20.034,5.669       c0.226,0.034,0.449,0.065,0.675,0.095c0.184,0.024,0.369,0.048,0.552,0.071c0.471,0.061,0.94,0.118,1.415,0.17       c1.283,0.14,2.576,0.253,3.878,0.331c21.117,1.296,41.477-5.711,57.325-19.73c5.021-4.442,9.4-9.42,13.079-14.819       c7.934-11.64,12.62-25.242,13.504-39.666c1.294-21.12-5.713-41.477-19.73-57.325c-14.015-15.849-33.366-25.291-54.487-26.582       c-14.332-0.881-28.605,2.131-41.28,8.712l-4.403-8.487c14.208-7.377,30.208-10.757,46.269-9.771       c23.668,1.449,45.354,12.031,61.062,29.792c15.709,17.762,23.563,40.576,22.111,64.245       c-0.991,16.167-6.242,31.41-15.131,44.455c-4.122,6.049-9.029,11.628-14.66,16.607c-17.761,15.71-40.576,23.563-64.245,22.113       C1843.496,1380.839,1828.31,1375.357,1815.552,1366.658z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2309.1,820.322c-0.851-0.52-1.438-1.439-1.489-2.511c-0.194-4.126-0.477-8.259-0.838-12.29       c-0.155-1.713,1.108-3.225,2.821-3.379c1.713-0.15,3.227,1.111,3.38,2.823c0.371,4.116,0.661,8.339,0.859,12.553       c0.081,1.718-1.246,3.176-2.963,3.256C2310.223,820.806,2309.614,820.636,2309.1,820.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1855.784,1088.583c-6.203-3.795-12.332-7.857-18.215-12.08       c-1.398-1.001-1.718-2.947-0.715-4.344c1.001-1.394,2.925-1.74,4.344-0.715c6.775,4.857,13.859,9.479,21.057,13.769       c0.012,0.007,0.022,0.013,0.032,0.02c1.453,0.889,1.924,2.781,1.05,4.25c-0.879,1.476-2.79,1.962-4.268,1.082       C1857.969,1089.908,1856.873,1089.249,1855.784,1088.583z M1895.92,1109.113c-1.289-0.788-1.847-2.42-1.245-3.856       c0.664-1.586,2.489-2.334,4.075-1.671c7.701,3.224,15.64,6.159,23.599,8.728c1.65,0.517,2.536,2.282,2.008,3.92       c-0.527,1.634-2.284,2.535-3.918,2.006c-8.126-2.622-16.232-5.62-24.093-8.91       C1896.196,1109.268,1896.053,1109.195,1895.92,1109.113z M1959.844,1127.89c-1.061-0.649-1.673-1.9-1.442-3.199       c0.297-1.693,1.915-2.825,3.608-2.524c8.243,1.456,16.632,2.574,24.932,3.324c1.711,0.149,2.976,1.667,2.822,3.38       c-0.155,1.713-1.669,2.975-3.382,2.822c-8.475-0.764-17.039-1.907-25.455-3.394       C1960.531,1128.229,1960.166,1128.087,1959.844,1127.89z M2026.313,1132.077c-0.85-0.52-1.436-1.434-1.488-2.504       c-0.085-1.717,1.238-3.178,2.956-3.265c8.328-0.413,16.751-1.196,25.037-2.329c1.704-0.234,3.276,0.956,3.508,2.663       c0.234,1.704-0.958,3.274-2.664,3.507c-8.463,1.157-17.067,1.958-25.572,2.38       C2027.441,1132.56,2026.828,1132.391,2026.313,1132.077z M2092.02,1121.302c-0.645-0.394-1.149-1.024-1.37-1.811       c-0.467-1.655,0.496-3.375,2.151-3.843c8.03-2.264,16.07-4.906,23.895-7.851c1.612-0.604,3.405,0.215,4.013,1.817       c0.605,1.61-0.208,3.405-1.817,4.011c-7.994,3.009-16.202,5.706-24.401,8.019       C2093.621,1121.89,2092.735,1121.739,2092.02,1121.302z M2153.711,1096.187c-0.45-0.275-0.837-0.669-1.108-1.166       c-0.821-1.511-0.263-3.401,1.247-4.224c7.35-3.999,14.608-8.353,21.571-12.945c1.436-0.947,3.369-0.552,4.313,0.885       c0.947,1.435,0.552,3.367-0.885,4.314c-7.111,4.687-14.521,9.134-22.023,13.217       C2155.814,1096.818,2154.63,1096.749,2153.711,1096.187z M2208.336,1058.056c-0.261-0.16-0.503-0.361-0.716-0.602       c-1.134-1.293-1.008-3.258,0.283-4.393c6.277-5.518,12.392-11.373,18.171-17.402c1.192-1.243,3.153-1.283,4.403-0.091       c1.241,1.191,1.283,3.159,0.093,4.402c-5.903,6.156-12.145,12.134-18.555,17.766       C2210.967,1058.659,2209.469,1058.748,2208.336,1058.056z M2253.139,1008.743c-0.067-0.041-0.133-0.085-0.199-0.132       c-1.395-1.006-1.71-2.953-0.703-4.348c4.317-5.985,8.455-12.205,12.298-18.488c0.513-0.838,1.023-1.681,1.526-2.524       c0.882-1.478,2.793-1.959,4.27-1.077c0.01,0.006,0.02,0.012,0.028,0.017c1.454,0.889,1.925,2.785,1.049,4.253       c-0.516,0.864-1.036,1.723-1.561,2.581c-3.926,6.418-8.151,12.769-12.562,18.883       C2256.328,1009.236,2254.515,1009.585,2253.139,1008.743z M2285.775,950.669c-1.292-0.79-1.846-2.427-1.24-3.864       c3.242-7.68,6.2-15.614,8.792-23.578c0.531-1.635,2.29-2.531,3.925-1.998c1.633,0.546,2.53,2.289,1.998,3.924       c-2.647,8.133-5.667,16.231-8.976,24.071c-0.669,1.587-2.495,2.327-4.081,1.66       C2286.047,950.821,2285.907,950.75,2285.775,950.669z M2304.733,886.795c-1.062-0.65-1.674-1.905-1.44-3.205       c1.481-8.248,2.62-16.634,3.391-24.931c0.157-1.711,1.675-2.972,3.386-2.812c1.714,0.161,2.975,1.673,2.813,3.389       c-0.785,8.471-1.948,17.034-3.46,25.452c-0.303,1.693-1.923,2.82-3.615,2.516       C2305.415,887.133,2305.055,886.992,2304.733,886.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1805.849,1050.173c-0.187-0.114-0.365-0.248-0.531-0.406c-3.057-2.922-6.055-5.907-8.912-8.874       c-1.192-1.239-1.156-3.209,0.082-4.402c1.239-1.195,3.208-1.146,4.404,0.081c2.796,2.905,5.735,5.829,8.731,8.692       c1.243,1.188,1.286,3.161,0.099,4.402C1808.69,1050.746,1807.072,1050.922,1805.849,1050.173z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1713.405,835.789c-0.891-0.545-1.487-1.523-1.492-2.645c-0.016-4.149,0.055-8.382,0.215-12.58       c0.064-1.719,1.512-3.06,3.229-2.994c1.722,0.07,3.059,1.511,2.994,3.229c-0.155,4.112-0.226,8.257-0.209,12.32       c0.007,1.719-1.382,3.118-3.101,3.126C1714.441,836.248,1713.881,836.08,1713.405,835.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1717.941,782.933c-1.061-0.649-1.672-1.9-1.442-3.199c1.455-8.243,3.281-16.547,5.427-24.684       c0.44-1.663,2.144-2.656,3.805-2.217c1.655,0.449,2.657,2.142,2.217,3.805c-2.103,7.971-3.892,16.106-5.318,24.18       c-0.298,1.693-1.913,2.822-3.606,2.524C1718.629,783.272,1718.264,783.131,1717.941,782.933z M1736.288,719.993       c-1.284-0.785-1.843-2.41-1.247-3.847c3.218-7.766,6.803-15.48,10.651-22.925c0.79-1.527,2.669-2.125,4.195-1.333       c1.549,0.798,2.127,2.667,1.336,4.196c-3.768,7.288-7.278,14.84-10.43,22.447c-0.657,1.587-2.48,2.344-4.069,1.685       C1736.572,720.153,1736.425,720.077,1736.288,719.993z M1767.937,662.578c-0.058-0.036-0.117-0.075-0.174-0.114       c-1.404-0.991-1.739-2.935-0.748-4.34c4.838-6.851,10.031-13.583,15.437-20.012c1.108-1.315,3.072-1.482,4.388-0.378       c1.317,1.105,1.486,3.069,0.38,4.385c-5.295,6.296-10.38,12.889-15.115,19.596       C1771.151,663.064,1769.325,663.427,1767.937,662.578z M1811.432,613.531c-0.249-0.152-0.481-0.341-0.687-0.57       c-1.152-1.275-1.054-3.243,0.223-4.398c6.223-5.625,12.766-11.056,19.447-16.144c1.368-1.042,3.324-0.782,4.363,0.591       c1.043,1.369,0.779,3.321-0.589,4.363c-6.544,4.984-12.952,10.303-19.047,15.811       C1814.095,614.13,1812.578,614.232,1811.432,613.531z M1864.587,575.18c-0.436-0.267-0.813-0.643-1.081-1.121       c-0.848-1.495-0.324-3.395,1.174-4.244c7.301-4.136,14.867-8.013,22.49-11.527c1.562-0.72,3.409-0.039,4.13,1.525       c0.72,1.563,0.037,3.413-1.524,4.133c-7.466,3.44-14.875,7.238-22.027,11.29       C1866.729,575.813,1865.521,575.752,1864.587,575.18z M1924.807,549.312c-0.626-0.383-1.122-0.989-1.353-1.747       c-0.501-1.647,0.427-3.385,2.073-3.887c8.034-2.45,16.263-4.581,24.458-6.345c1.678-0.357,3.338,0.712,3.698,2.39       c0.361,1.682-0.708,3.338-2.39,3.7c-8.024,1.725-16.083,3.815-23.952,6.213C1926.454,549.906,1925.54,549.76,1924.807,549.312z        M1989.204,537.241c-0.826-0.505-1.404-1.387-1.483-2.426c-0.128-1.714,1.159-3.209,2.873-3.336       c8.376-0.626,16.876-0.902,25.263-0.819c1.716,0.023,3.098,1.428,3.083,3.145c-0.019,1.721-1.425,3.099-3.147,3.083       c-8.211-0.082-16.534,0.188-24.734,0.8C1990.383,537.738,1989.741,537.569,1989.204,537.241z M2054.695,539.623       c-1.034-0.632-1.644-1.84-1.458-3.112c0.254-1.702,1.836-2.876,3.537-2.624c8.276,1.226,16.626,2.82,24.819,4.741       c1.684,0.382,2.714,2.07,2.322,3.741c-0.393,1.674-2.068,2.713-3.742,2.32c-8.027-1.88-16.205-3.443-24.311-4.644       C2055.435,539.984,2055.041,539.835,2054.695,539.623z M2118.103,556.225c-1.256-0.768-1.825-2.343-1.281-3.768       c0.615-1.606,2.414-2.408,4.021-1.796c7.865,3.007,15.674,6.376,23.211,10.01c1.542,0.769,2.199,2.611,1.453,4.157       c-0.748,1.549-2.61,2.2-4.158,1.453c-7.38-3.559-15.027-6.858-22.731-9.802C2118.436,556.41,2118.264,556.323,2118.103,556.225       z M2196.617,600.955c-0.109-0.067-0.215-0.139-0.316-0.221c-6.443-5.114-13.177-10.014-20.017-14.558       c-1.432-0.951-1.822-2.883-0.871-4.315c0.954-1.434,2.874-1.864,4.318-0.87c6.986,4.64,13.864,9.643,20.443,14.869       c1.345,1.069,1.573,3.026,0.502,4.374C2199.687,601.478,2197.939,601.763,2196.617,600.955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2235.153,637.635c-0.261-0.16-0.503-0.361-0.716-0.602c-2.721-3.098-5.52-6.154-8.32-9.082       c-1.188-1.243-1.142-3.215,0.1-4.402c1.245-1.188,3.212-1.151,4.404,0.099c2.857,2.992,5.716,6.113,8.495,9.274       c1.134,1.293,1.008,3.258-0.283,4.393C2237.782,638.241,2236.285,638.328,2235.153,637.635z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2202.584,703.479c-0.715-1.347-2.207-2.093-3.714-1.856l-42.994,6.768        c-13.375-15.304-29.287-28.586-47.363-39.111l-1.515-43.468c-0.053-1.525-1.068-2.847-2.526-3.294l-49.916-15.289        c-1.459-0.447-3.041,0.082-3.938,1.314l-25.599,35.164c-20.87-1.402-41.49,0.688-61.143,5.877l-31.829-29.685        c-1.115-1.04-2.768-1.258-4.115-0.543l-46.107,24.485c-1.349,0.716-2.093,2.208-1.856,3.714l6.767,42.993        c-15.304,13.375-28.585,29.288-39.111,47.363l-43.469,1.515c-1.525,0.053-2.847,1.067-3.294,2.526l-15.289,49.917        c-0.447,1.458,0.081,3.04,1.315,3.938l35.164,25.599c-1.403,20.87,0.688,41.49,5.876,61.142l-29.685,31.829        c-1.04,1.115-1.258,2.769-0.543,4.116l24.485,46.107c0.715,1.348,2.208,2.093,3.715,1.856l42.993-6.767        c13.375,15.304,29.287,28.586,47.363,39.111l1.515,43.469c0.053,1.524,1.068,2.847,2.526,3.294l49.917,15.29        c1.458,0.447,3.04-0.082,3.937-1.315l25.599-35.164c20.87,1.404,41.491-0.688,61.143-5.877l31.828,29.685        c1.115,1.041,2.769,1.259,4.116,0.543l46.107-24.485c1.347-0.716,2.093-2.207,1.856-3.714l-6.767-42.993        c15.304-13.375,28.585-29.288,39.111-47.364l43.469-1.515c1.523-0.053,2.847-1.068,3.293-2.526l15.289-49.916        c0.447-1.459-0.081-3.04-1.314-3.938l-35.164-25.599c1.402-20.87-0.69-41.49-5.877-61.142l29.685-31.829        c1.041-1.115,1.259-2.768,0.544-4.116L2202.584,703.479z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1985.805,877.622c-4.13-2.526-7.918-5.66-11.258-9.349       c-9.144-10.106-13.806-23.167-13.125-36.781c0.679-13.612,6.619-26.144,16.726-35.289       c10.107-9.146,23.169-13.806,36.782-13.126c13.611,0.68,26.146,6.618,35.291,16.726c9.145,10.107,13.806,23.17,13.123,36.783       c-0.678,13.612-6.619,26.144-16.726,35.289c-10.107,9.145-23.169,13.806-36.782,13.126       C2001.195,884.57,1992.986,882.015,1985.805,877.622z M2034.099,798.435c-5.868-3.589-12.573-5.673-19.636-6.026l0,0       c-11.12-0.557-21.79,3.25-30.046,10.722c-8.256,7.469-13.109,17.707-13.665,28.828c-0.555,11.121,3.253,21.792,10.724,30.047       c7.468,8.261,17.707,13.113,28.83,13.664c11.12,0.557,21.79-3.25,30.046-10.722c8.256-7.469,13.109-17.707,13.665-28.828       c0.555-11.12-3.251-21.794-10.722-30.05C2040.567,803.058,2037.472,800.498,2034.099,798.435z M2014.697,787.743l0.026,0.016       L2014.697,787.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1943.288,946.107c-49.635-30.362-74.561-91.583-56.752-149.726       c3.286-10.73,7.836-20.73,13.438-29.89c30.358-49.643,91.586-74.574,149.736-56.766c1.044,0.321,2.085,0.655,3.123,1.001       c6.991,2.334,13.77,5.243,20.214,8.679c0.754,0.401,1.503,0.809,2.247,1.225l-4.557,8.156       c-7.478-4.179-15.475-7.587-23.764-10.127c-0.077-0.026-0.156-0.049-0.234-0.072c-63.885-19.427-131.707,16.657-151.27,80.528       c-19.586,63.95,16.503,131.906,80.458,151.504c53.989,16.535,110.84-6.614,139.027-52.706       c5.202-8.506,9.426-17.789,12.477-27.75c6.439-21.025,7.064-43.36,1.805-64.585l9.067-2.246       c5.665,22.868,4.996,46.923-1.939,69.565c-3.287,10.729-7.836,20.729-13.439,29.889       c-30.358,49.643-91.586,74.575-149.735,56.767C1962.457,956.264,1952.449,951.71,1943.288,946.107z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103962963768557854040000016941801697984335511_",
    gradientUnits: "userSpaceOnUse",
    x1: -2158.5271,
    y1: 1373.4154,
    x2: -2009.9471,
    y2: 1767.1531,
    gradientTransform: "matrix(-1 0 0 1 -929.111 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103962963768557854040000016941801697984335511_)"
    },
    d: "M1268.074,1441.605l-29.193,28.788      c-41.443-3.984-73.38-16.876-97.909-33.232c14.761-36.709,29.754-58.485,41.533-71.244      C1221.086,1420.179,1268.074,1441.605,1268.074,1441.605z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006679799101948530100000008142987950411687844_",
    gradientUnits: "userSpaceOnUse",
    x1: 1054.818,
    y1: 881.5923,
    x2: 1105.3185,
    y2: 1224.995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006679799101948530100000008142987950411687844_)"
    },
    d: "M1064.87,1333.884l68.899-107.721      c4.519,60.761,25.046,106.436,48.735,139.754c-11.779,12.759-26.772,34.535-41.533,71.244      C1079.759,1396.347,1064.87,1333.884,1064.87,1333.884z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031197745976534748140000015846158189947008954_",
    gradientUnits: "userSpaceOnUse",
    x1: 10898.6943,
    y1: 2155.5132,
    x2: 11046.2061,
    y2: 2155.5132,
    gradientTransform: "matrix(1 0 0 1 -9962.5537 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031197745976534748140000015846158189947008954_)"
    },
    d: "M991.599,2185.255     c34.35,1.581,67.598,0.588,89.798-0.553c-20.213-14.387-66.778-45.688-105.744-58.15l-26.749-1.6c0,0-9.064,13.785-12.297,45.33     C941.039,2175.812,953.997,2183.525,991.599,2185.255z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012452943116770981860000018228868315770859139_",
    gradientUnits: "userSpaceOnUse",
    x1: 1009.897,
    y1: 1856.5231,
    x2: 1009.897,
    y2: 2161.8621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012452943116770981860000018228868315770859139_)"
    },
    d: "M1081.673,2184.897     c-0.089-0.063-0.187-0.132-0.277-0.196c-22.2,1.141-55.448,2.134-89.798,0.553c-37.602-1.73-50.559-9.443-54.992-14.974     c-0.149,1.453-0.302,2.896-0.424,4.425c-0.555,6.923,4.583,13,11.507,13.524c28.132,2.127,97.883,6.944,131.519,5.18     C1083.645,2193.178,1085.291,2187.476,1081.673,2184.897z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183939028529387431520000012369412816723350437_",
    gradientUnits: "userSpaceOnUse",
    x1: 10639.5645,
    y1: 2155.8813,
    x2: 10708.6348,
    y2: 2155.8813,
    gradientTransform: "matrix(1 0 0 1 -9962.5537 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183939028529387431520000012369412816723350437_)"
    },
    d: "M745.919,2176.062     c-2.515-16.126-6.549-39.438-9.665-45.398c-4.89-9.351-21.627,0-21.627,0s-11.75,5.479-17.158,14.612     c-3.447,5.821-12.981,22.385-19.441,33.63c-0.743,1.293-1.053,2.67-1.014,4.003l67.021,2.346     C745.672,2182.625,746.443,2179.419,745.919,2176.062z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076588501309080042590000010800398988822678463_",
    gradientUnits: "userSpaceOnUse",
    x1: 686.1702,
    y1: 1928.4497,
    x2: 717.2214,
    y2: 2254.4888
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076588501309080042590000010800398988822678463_)"
    },
    d: "M677.014,2182.909     c0.112,3.828,3.146,7.301,7.427,7.419l47.747,1.314c5.045,0.139,9.413-2.483,11.846-6.387L677.014,2182.909z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155127123014896309330000001288731665841278613_",
    gradientUnits: "userSpaceOnUse",
    x1: 10668.7764,
    y1: 2108.2642,
    x2: 10713.5928,
    y2: 2108.2642,
    gradientTransform: "matrix(1 0 0 1 -9962.5537 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155127123014896309330000001288731665841278613_)"
    },
    d: "M751.04,2077.066     c-0.578,1.935-9.239,43.917-13.03,62.343c-1.048,5.093-5.635,8.668-10.828,8.408c-2.836-0.142-6.136-0.397-9.596-0.845     c-6.139-0.795-10.814-5.921-11.049-12.106c-0.615-16.14-0.917-47.129,5.01-59.137     C719.722,2059.164,751.04,2077.066,751.04,2077.066z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000195967599148588470000009742503452348746643_",
    gradientUnits: "userSpaceOnUse",
    x1: 10906.1973,
    y1: 2105.3308,
    x2: 10943.5498,
    y2: 2105.3308,
    gradientTransform: "matrix(1 0 0 1 -9962.5537 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000195967599148588470000009742503452348746643_)"
    },
    d: "M943.644,2089.086     c3.714-0.118-1.482,19.178,4.138,38.144c1.268,4.278,4.467,7.635,8.928,7.692c2.891,0.037,6.317-0.018,9.796-0.298     c5.232-0.419,9.435-4.479,9.921-9.704l4.572-49.192L943.644,2089.086z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120537441288840997370000009197433140675612052_",
    gradientUnits: "userSpaceOnUse",
    x1: 1117.6434,
    y1: 1192.1376,
    x2: 837.263,
    y2: 2093.9043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120537441288840997370000009197433140675612052_)"
    },
    d: "M1047.539,1566.171     c-1.658,8.07-60.175,349.384-63.725,525.998c-0.06,2.961-2.239,5.445-5.172,5.853c-7.429,1.036-21.896,2.367-35.923-0.234     c-1.921-0.356-3.369-1.938-3.49-3.887c-2.045-32.913-18.493-311.186,1.65-442.182c0,0-166.381,350.172-191.601,446.728     c-0.614,2.35-2.77,3.929-5.195,3.801c-7.126-0.376-21.944-1.658-33.711-5.989c-4.218-1.552-6.62-5.985-5.555-10.351     c14.091-57.785,112.842-455.905,179.891-543.621L1047.539,1566.171z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119102874231032484000000008459425119345777553_",
    gradientUnits: "userSpaceOnUse",
    x1: 10999.0811,
    y1: 1531.0682,
    x2: 10846.2021,
    y2: 1728.7194,
    gradientTransform: "matrix(1 0 0 1 -9962.5537 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119102874231032484000000008459425119345777553_)"
    },
    d: "M940.879,1653.901     c-0.551,0-1.102-0.207-1.527-0.623c-0.862-0.842-0.878-2.227-0.034-3.088l22.279-22.783c0.843-0.864,2.226-0.876,3.088-0.034     c0.862,0.842,0.878,2.226,0.034,3.088l-22.279,22.782C942.013,1653.682,941.446,1653.901,940.879,1653.901z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121973350441255792870000004674737280905965476_",
    gradientUnits: "userSpaceOnUse",
    x1: 1328.0106,
    y1: 1119.2834,
    x2: 876.8727,
    y2: 1422.287
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121973350441255792870000004674737280905965476_)"
    },
    d: "M1142.646,1138.849     c-42.737-11.195-121.57-28.727-184.327-24.985c-14.414,0.859-25.964,12.255-26.782,26.671     c-9.48,167.139-22.435,315.456-46.83,401.752c54.836,21.7,109.199,31.765,162.831,23.884     c40.179-86.06,75.307-185.414,105.323-298.245c0,0,17.609-89.994,0.51-119.99     C1150.705,1143.259,1147.196,1140.041,1142.646,1138.849z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039130105107858276150000009974617386820499362_",
    gradientUnits: "userSpaceOnUse",
    x1: 999.258,
    y1: 1158.0327,
    x2: 1164.2263,
    y2: 969.4974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039130105107858276150000009974617386820499362_)"
    },
    d: "M1039.849,1021.768     c0,0-10.791,64.383-14.009,94.158c-0.523,4.839,2.008,9.413,6.335,11.641c11.795,6.072,36.975,15.852,64.411,6.877     c4.519-1.478,7.481-5.85,7.377-10.603l-1.882-85.953L1039.849,1021.768z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179635362163425983360000004353679473926059441_",
    gradientUnits: "userSpaceOnUse",
    x1: 10982.4482,
    y1: 1064.9984,
    x2: 10863.4131,
    y2: 1156.0782,
    gradientTransform: "matrix(1 0 0 1 -9962.5537 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179635362163425983360000004353679473926059441_)"
    },
    d: "M1110.234,950.432      c0,0,20.822,47.833,22.221,72.938c1.398,25.106,6.808,41.396-22.221,46.452c-29.029,5.055-53.483-9.406-66.731-34.413      c0,0-20.757-38.535-16.101-54.316C1032.058,965.312,1110.234,950.432,1110.234,950.432z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097484903954301058630000002853137761370740903_",
    gradientUnits: "userSpaceOnUse",
    x1: 10993.5254,
    y1: 920.6372,
    x2: 11101.3135,
    y2: 1059.4138,
    gradientTransform: "matrix(1 0 0 1 -9962.5537 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097484903954301058630000002853137761370740903_)"
    },
    d: "M1053.422,1017.428h3.67      c0,0-15.121-31.015-1.835-36.463c13.285-5.449,65.912-16.181,77.267-34.854c10.946-18.002,1.184-41.256-13.422-47.763      c-0.924-0.412-2.014,0.023-2.486,0.918l-1.21,2.289c-0.828,1.568-3.144,1.331-3.637-0.373l0,0      c-0.468-1.616-2.646-1.969-3.535-0.54c-3.476,5.584-12.887,14.665-38.13,19.323c-35.818,6.61-59.496,21.106-60.078,45.86      c-0.037,1.568-1.713,2.433-3.053,1.616c-2.644-1.611-6.876-2.368-12.531,2.388c-9.835,8.27-5.81,29.721,15.749,47.368      c1.025,0.839,1.016,2.438-0.093,3.16c-3.909,2.545-9.734,8.598,5.363,16.668c15.444,8.256,24.583,7.355,28.032,6.473      c0.928-0.237,1.552-1.083,1.493-2.039l-1.356-21.937c-0.07-1.134,0.831-2.093,1.968-2.093H1053.422z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020378297887572882160000008786176655130044820_",
    gradientUnits: "userSpaceOnUse",
    x1: 11062.3877,
    y1: 973.2386,
    x2: 10943.3525,
    y2: 1064.3185,
    gradientTransform: "matrix(1 0 0 1 -9962.5537 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020378297887572882160000008786176655130044820_)"
    },
    d: "M1054.324,1022.018      c0,0-7.944-30.555-21.642-21.987c-13.699,8.567,7.109,34.235,18.122,35.379L1054.324,1022.018z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003820577422460090640000013610176006933323149_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.9436,
    y1: 1514.9385,
    x2: 1479.5417,
    y2: 1514.9385
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003820577422460090640000013610176006933323149_)"
    },
    d: "M609.823,1519.133l-28.122,7.108      c-48.256,12.198-80.708,48.462-72.484,80.999l9.777,38.682c8.224,32.537,54.01,49.025,102.266,36.828l28.122-7.108      c1.862-0.47,3.715-0.981,5.554-1.532l824.604-246.729l-21.301-84.274l-842.802,174.735      C613.559,1518.232,611.685,1518.662,609.823,1519.133z M621.934,1557.74c36.331-9.183,70.207,0.871,75.664,22.46      c5.457,21.588-19.572,46.533-55.903,55.717c-36.331,9.183-70.208-0.873-75.664-22.461      C560.573,1591.868,585.602,1566.924,621.934,1557.74z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137811612478894497180000009779841244982326706_",
    gradientUnits: "userSpaceOnUse",
    x1: 1408.4263,
    y1: 1348.521,
    x2: 1812.397,
    y2: 1348.521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137811612478894497180000009779841244982326706_)"
    },
    d: "M1732.41,1228.598l-163.174,41.245      c-11.618,2.937-21.214,11.099-25.977,22.096l-24.414,56.369c-6.968,16.09-2.225,34.854,11.552,45.7l48.266,37.997      c9.416,7.412,21.739,10.034,33.357,7.098l163.174-41.245c24.613-6.222,45.524,19.467,33.904,42.038      c-27.799,53.996-78.807,96.704-143.73,113.115c-117.346,29.661-221.197-41.435-249.727-154.306      c-28.53-112.871,29.065-224.775,146.411-254.437c64.924-16.411,130.099-3.069,180.216,31.232      C1763.216,1189.838,1757.022,1222.377,1732.41,1228.598z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067917415373888943980000007080349779217795459_",
    gradientUnits: "userSpaceOnUse",
    x1: -1144.3145,
    y1: 17917.9375,
    x2: -1007.9697,
    y2: 16943.3262,
    gradientTransform: "matrix(-0.2451 -0.9695 -0.9695 0.2451 -2938.6108 4675.627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067917415373888943980000007080349779217795459_)"
    },
    d: "M1736.297,1243.977l-163.174,41.245      c-11.618,2.936-21.215,11.099-25.978,22.096l-24.414,56.368c-6.969,16.089-2.225,34.854,11.551,45.7l48.266,37.996      c9.416,7.413,21.739,10.035,33.357,7.098l163.174-41.245c24.612-6.221,45.524,19.468,33.903,42.039      c-27.799,53.995-78.806,96.704-143.73,113.115c-117.346,29.661-221.197-41.435-249.727-154.306      c-28.53-112.871,29.065-224.775,146.41-254.436c64.924-16.411,130.099-3.069,180.217,31.232      C1767.102,1205.216,1760.909,1237.755,1736.297,1243.977z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051367202374873071540000004655310979327547030_",
    gradientUnits: "userSpaceOnUse",
    x1: -368.5881,
    y1: 14228.2031,
    x2: -232.2439,
    y2: 13253.5957,
    gradientTransform: "matrix(-0.2451 -0.9695 -1.2017 0.3038 -2694.0115 4613.8496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051367202374873071540000004655310979327547030_)"
    },
    d: "M612.924,1531.4l-28.122,7.108      c-48.257,12.197-80.708,48.461-72.484,80.999l9.777,38.682c8.224,32.537,54.01,49.025,102.266,36.828l28.122-7.108      c1.862-0.47,3.715-0.981,5.554-1.531l824.604-246.729l-21.301-84.274l-842.802,174.735      C616.659,1530.499,614.786,1530.929,612.924,1531.4z M625.034,1570.007c36.331-9.183,70.207,0.872,75.663,22.46      c5.457,21.588-19.572,46.533-55.903,55.717c-36.331,9.183-70.208-0.873-75.664-22.461      C563.673,1604.135,588.703,1579.191,625.034,1570.007z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015343630436787903760000006890490672882761648_",
    gradientUnits: "userSpaceOnUse",
    x1: -1733.1737,
    y1: 1390.0212,
    x2: -1566.0204,
    y2: 1631.4645,
    gradientTransform: "matrix(-1 0 0 1 -929.111 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015343630436787903760000006890490672882761648_)"
    },
    d: "M820.944,1361.454      c-21.135,59.296-9.232,122.868-9.232,122.868l-27.859,7.429c0,0-35.99-42.806-27.756-137.795      C781.812,1350.032,805.897,1356.057,820.944,1361.454z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036939885314438792740000001935788453109370496_",
    gradientUnits: "userSpaceOnUse",
    x1: 1244.7321,
    y1: 995.2911,
    x2: 793.5935,
    y2: 1298.295
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036939885314438792740000001935788453109370496_)"
    },
    d: "M756.097,1353.956      c0.925-10.681,2.381-21.987,4.54-34.001c18.824-104.762,153.131-185.348,184.735-202.995c2.939-1.641,6.515,0.573,6.409,3.937      l-4.489,142.412c-74.8,10.054-110.203,52.853-126.347,98.145C805.897,1356.057,781.812,1350.032,756.097,1353.956z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012468534979815887370000010566350475710494641_",
    gradientUnits: "userSpaceOnUse",
    x1: -2263.0276,
    y1: 1412.8496,
    x2: -2114.4478,
    y2: 1806.5864,
    gradientTransform: "matrix(-1 0 0 1 -929.111 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012468534979815887370000010566350475710494641_)"
    },
    d: "M1326.837,1493.855     c5.22-1.442,9.465-5.156,11.672-10.101c4.276-9.583,9.095-24.936-1.193-29.612c-15.322-6.965-43.181,21.591-43.181,21.591     l-13.612,22.061l-12.448,6.055C1279.48,1506.987,1301.468,1501.757,1326.837,1493.855z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039823817773079673850000002880810355764700833_",
    gradientUnits: "userSpaceOnUse",
    x1: -1797.1882,
    y1: 1433.7318,
    x2: -1628.1033,
    y2: 1677.9652,
    gradientTransform: "matrix(-1 0 0 1 -929.111 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039823817773079673850000002880810355764700833_)"
    },
    d: "M809.853,1470.393h34.443     c0,0-27.941,16.757-28.87,34.38c-0.928,17.623,11.093,54.126,16.715,64.064c6.149,10.868-77.994-16.182-48.288-98.444H809.853z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041284867893399884720000016472890123907175357_",
    gradientUnits: "userSpaceOnUse",
    x1: 2100.9333,
    y1: 3188.2373,
    x2: 2245.7007,
    y2: 2582.2332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041284867893399884720000016472890123907175357_)"
    },
    d: "M2510.939,3158.543v29.522     c0,7.558-3.885,13.802-9.016,14.483l-460.591,41.742c-3.417,0.475-6.853,0.387-10.25-0.204c-0.886-0.162-1.773-0.353-2.661-0.572     l-320.917-60.492c-3.413-0.882-5.922-5.347-5.922-10.532v-31.191l340.497-42.203l43.83-20.744l43.581,6.278l25.736-4.933     l58.82,17.119L2510.939,3158.543z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102510169632067068600000012980385897738286014_",
    gradientUnits: "userSpaceOnUse",
    x1: 2271.6099,
    y1: 3132.7407,
    x2: 2352.4109,
    y2: 2503.1672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102510169632067068600000012980385897738286014_)"
    },
    d: "M2510.939,3158.543v29.522     c0,7.558-3.885,13.802-9.016,14.483l-460.571,41.739c-3.417,0.475-7.681,0.363-10.229-0.207v-159.03l54.807-6.702l43.571,6.279     l25.73-4.932l58.817,17.119L2510.939,3158.543z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174580107367790682040000007582085526266394263_",
    gradientUnits: "userSpaceOnUse",
    x1: 2178.1328,
    y1: 2630.7224,
    x2: 2130.999,
    y2: 2970.7588
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174580107367790682040000007582085526266394263_)"
    },
    d: "M2155.226,3079.696l-453.644,60.216     l327.206,61.631c4.027,1.03,8.121,1.27,12.175,0.715l469.975-43.714L2155.226,3079.696z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056396329139003205980000002730498652338377866_",
    gradientUnits: "userSpaceOnUse",
    x1: 3265.196,
    y1: 155.3778,
    x2: 3029.5273,
    y2: 747.9151
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056396329139003205980000002730498652338377866_)"
    },
    d: "M2321.524,3134.085      c0,21.605-67.992,38.4-161.848,42.76c-23.694,1.091-49.021,1.394-75.299,0.788c-129.175-2.979-232.973-27.007-232.973-53.61      c0-0.603,0.071-1.913,0.179-1.911l-0.179-0.004l0.536-1.282c0.125-0.437,0.285-0.833,0.482-1.24l29.792-77.881l35.977-93.976      l50.384-131.71l38.561-100.82l47.969-125.364c6.002-15.696,17.123-25.453,29.145-25.453c1.635,0,3.234,0.167,4.815,0.526      c10.145,2.215,19.206,11.354,24.412,24.956l48.374,126.245l38.631,102.15l50.974,134.352v0.028l36.599,96.531v0.028l0.582,0.056      l30.479,78.449C2320.428,3129.798,2321.524,3131.936,2321.524,3134.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2288.636,3049.255c-29.411,9.828-76.427,16.905-132.713,19.537      c-22.685,1.068-46.683,1.413-71.687,0.938c-86.792-1.65-162.042-12.816-202.092-28.005l36.012-93.985      c42.139,9.479,100.871,15.87,166.149,16.853c21.109,0.318,41.677,0.045,61.265-0.742c41.22-1.631,77.564-5.587,106.197-11.207      l36.286,96.527v0.028L2288.636,3049.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2200.921,2818.261c-22.45,2.425-47.127,4.074-73.308,4.818      c-14.027,0.417-28.476,0.554-43.236,0.41c-42.245-0.412-81.755-3.113-115.802-7.465l38.561-100.823      c24.134,1.905,50.126,2.994,77.24,3.151c9.578,0.055,19.017-0.001,28.281-0.196c16.997-0.318,33.469-1,49.192-2.047      L2200.921,2818.261z"
  }))))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    text {\n      font-family: 'Orbitron', sans-serif;\n      font-weight: 700;\n      fill: #333;\n    }\n  ")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "55%",
    y: "92%",
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontSize: 100
  }, "\n    COMING SOON\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming-soon.5eba11803ab70b8f389c09ba3048983b.svg";
export { ForwardRef as ReactComponent };